<!--
    描述：新版商详页，在这里控制AB，由于Comsume中的一些静态资源、依赖、组件引用的是Detail下的资源，所以老版商详页暂时不能删掉，后续需要做解耦
    创建时间：2022/6/27
    新版prd：https://docs.corp.kuaishou.com/d/home/fcABMXzEkjfb7LJ-Lu013XQ54
    新版ui：https://www.figma.com/file/xRSvakX5uyNLm34TfRknRy/%E8%AF%A6%E6%83%85%E9%A1%B5%E6%94%B9%E7%89%88?node-id=123%3A14209
    状态区分（按照角色）：消费者（已购买、未购买）、生产者（浏览态、发布时的预览态）、帮卖者
    状态区分（按照课程）：录播、直播课、站外课
    pm：mujiayuan
    TODO： 快币充值
-->
<template>
    <PageLoadComponent :loading-state="isLoading">
        <div class="detail-content">
            <!-- 课程下架提示 -->
            <div
                v-if="
                    dataCourse?.courseSellStatus &&
                    dataCourse?.courseSellStatus !== 'NORMAL' &&
                    !isPackageCourseFlag
                "
                class="course-offline-tip"
            >
                <img src="./img/tip.png" />
                <span>{{ COURSE_OFFLINE_TIP_TEXT }}</span>
            </div>
            <!-- 更新提示 -->
            <Marquee
                v-if="shouldShowUpdateTip && showSellStatus"
                text="为保证更好的观看体验，请更新APP至最新版"
                :is-speaker="true"
                right-text="去更新"
                :show-arrow="true"
                @right-click="onUpdateClick"
            >
            </Marquee>
            <!-- 课程封面图（头部）-->
            <Cover
                :course="dataCourseFirst"
                :distribution-id="distributionId"
            ></Cover>
            <!-- 课程sku选择, 切换sku切换页面课程内容 -->
            <AboutSku
                :course-id="courseId"
                :data-user-role="dataUserRole"
            ></AboutSku>
            <!-- 课程的相关信息，包含价格、名称、集数、权益 -->
            <Info
                v-if="dataCourse?.courseId"
                :data-course="dataCourse"
                :course="dataCourseFirst"
                :voucher-list="voucherList"
                :trade-info="courseTradeInfo"
                :use-kscoin-pay="useKscoinPay"
                :data-lessons="dataLessons"
                :data-task="dataTask"
                :data-user-role="dataUserRole"
                :data-course-distribution="dataCourseDistribution"
                :is-free-course="isFreeCourse"
                :subscriber-count="subscriberCount"
                :display-subscriber-count="displaySubscriberCount"
                :display-sold-info-str="displaySoldInfoStr"
                :is-seven-screen="isSevenScreen"
                :data-tags="dataTags"
                :from="from"
                :data-my-distribution-status="dataMyDistributionStatus"
                @voucher-popup-show="voucherPopupShow"
                @buy-course="buyCourse"
                @apply-distribution="applyDistribution"
            ></Info>
            <template v-if="dataCourse">
                <!-- 物流信息 -->
                <FastMail
                    v-if="deliveryInfoList.length"
                    :delivery-info-list="deliveryInfoList"
                ></FastMail>
                <!-- 发表评论模块 -->
                <Evaluate
                    :can-course-evaluate="canCourseEvaluate"
                    :rest-days="restDays"
                    :data-user-role="dataUserRole"
                    @to-evaluate="toEvaluate"
                ></Evaluate>
                <!-- 0元抢大额券 -->
                <Coupon
                    v-if="isCouponShow"
                    v-visible="{
                        ignoreInitial: false,
                        ratio: 0.8,
                        logBridge: {
                            name: 'GRAB_COUPON_BANNER',
                        },
                    }"
                    @go-link="goLink"
                    @countdown-end="isCouponShow = false"
                ></Coupon>
                <!-- 用户权益、提醒 -->
                <Equity
                    :data-tags="dataTags"
                    :data-course="dataCourse"
                    :data-user-role="dataUserRole"
                    @handle-receive="handleReceive"
                ></Equity>
                <!-- 捆绑课 -->
                <Bundle v-if="bundleList.length" :bundle-list="bundleList" />
                <!-- 课程课节信息，如第一节，标题等 -->
                <Lesson
                    v-if="dataLessons.length > 1 && !isPackageCourseFlag"
                    ref="ElementLesson"
                    :data-lessons="dataLessons"
                    :data-course="dataCourse"
                    :data-user-role="dataUserRole"
                ></Lesson>
                <!-- 赠品介绍 -->
                <Gift
                    v-if="giftsName"
                    :gifts-name="giftsName"
                    :gift-img-urls="giftImgUrls"
                    :data-user-role="dataUserRole"
                ></Gift>
                <!-- 复购模块 -->
                <Reapeat
                    v-if="dataRecommendList.length > 0"
                    :data-recommend-list="dataRecommendList"
                    :data-recommend-more="dataRecommendMore"
                ></Reapeat>
                <!-- 评价列表 -->
                <Comment
                    v-if="dataEvaluation"
                    ref="ElementComment"
                    :data-evaluation="dataEvaluation"
                    :data-user-role="dataUserRole"
                ></Comment>
                <!-- 老师介绍 -->
                <Teacher
                    v-if="dataTeacherInfo"
                    ref="ElementIntroduce"
                    :data-course="dataCourse"
                    :data-teacher-info="dataTeacherInfo"
                    :data-user-role="dataUserRole"
                    :distribution-id="distributionId"
                    @open-ks-app="openKsApp"
                ></Teacher>
                <!-- 报名观众，只有直播课有 -->
                <SignUp v-if="isShowStudent"></SignUp>
                <!-- 课程介绍 -->
                <Introduce
                    v-if="dataCourse && dataUserRole"
                    :data-course="dataCourse"
                    :data-user-role="dataUserRole"
                ></Introduce>
                <!-- 客服与售后 -->
                <MyCustomer
                    :data-course="dataCourse"
                    :data-user-role="dataUserRole"
                    :customer-service-merchant-url="customerServiceMerchantUrl"
                ></MyCustomer>
                <!-- 付费内容用户协议 -->
                <Agreement
                    ref="RefAgreement"
                    v-model="myProtocolFlag"
                    v-model:follow-account="agreeFollow"
                    :data-course="dataCourse"
                    :data-user-role="dataUserRole"
                    :distribution-id="distributionId"
                    :data-gifts="dataGifts"
                ></Agreement>
                <!-- 复购 不同作者 -->
                <Recommend
                    v-if="dataUserRole?.hasAllCourseRight"
                    ref="ElementRecommend"
                    :course-id="courseId"
                    @change-show-recommend="changeShowRecommend"
                ></Recommend>
                <!-- 去广场btn -->
                <SquareBtn
                    v-if="showHomeEntry && !isHarmony"
                    @click="toSquare"
                ></SquareBtn>
                <!-- 投流的广告主公司名字 -->
                <div v-if="adCorporationName" class="corporation">
                    「{{ adCorporationName }}」
                </div>
                <!-- 课程导航 -->
                <Nav
                    v-show="navFlag"
                    ref="ElementNav"
                    :nav-selected="navSelected"
                    :lesson-lang="dataLessons.length"
                    :data-evaluation="dataEvaluation"
                    :data-course="dataCourse"
                    :show-recommend="showRecommend"
                    :style="{
                        opacity: navOpacity,
                    }"
                    @check-nav-action="checkNavAction"
                >
                </Nav>
                <!-- 购买/试看的footer -->
                <BottomBar
                    v-show="bottomBarFlag"
                    :bottom-bar-distance="bottomBarDistance"
                    :fix-ios-seven-flag="fixIosSevenFlag"
                    :fix-ios-seven-height="fixIosSevenHeight"
                    :data-can-live-trial="dataCanLiveTrial"
                    :use-kscoin-pay="useKscoinPay"
                    :data-course="dataCourse"
                    :data-teacher-info="dataTeacherInfo"
                    :data-lessons="dataLessons"
                    :data-user-role="dataUserRole"
                    :data-task="dataTask"
                    :course-trade-info="courseTradeInfo"
                    :nearest-lesson="nearestLesson"
                    :customer-service-merchant-url="customerServiceMerchantUrl"
                    :from="from"
                    :data-my-distribution-status="dataMyDistributionStatus"
                    :data-course-distribution="dataCourseDistribution"
                    :distributor-name="distributorName"
                    :distribution-id="distributionId"
                    @to-subscribe="toSubscribe"
                    @to-replay-list="toReplayList"
                    @open-ks-app="openKsApp"
                    @buy-course="buyCourse"
                    @apply-distribution="applyDistribution"
                    @watch-lesson-live="watchLessonLive"
                ></BottomBar>
                <!-- 领取优惠券的组件 -->
                <VoucherPopup
                    v-visible="{
                        ignoreInitial: false,
                        ratio: 0.8,
                        logBridge: {
                            name: 'STORE_COUPON_POPUP',
                        },
                    }"
                    :visible="voucherPopupFlag"
                    :list="voucherList"
                    @confirm="voucherPopupConfirm"
                    @close="voucherPopupClose"
                ></VoucherPopup>
                <!-- 同意协议的弹窗，当点击购买课（或是单节课）按钮的时候，如果用户没有勾选同意协议，则弹出此弹窗，这里是针对站外履约课或是赠品课的  -->
                <BoughtNoticeDialog
                    v-model="offSiteBoughtNoticePopupShow"
                    title="购买须知"
                    confirm-txt="同意并提交"
                    @agree="agreeUserInfoProtocol()"
                >
                    <template #content>
                        <div v-if="showUserInfoProtocalFlag">
                            <div class="content first">
                                1.&nbsp;快手付费内容将获取你的个人信息（快手昵称、头像、手机号、姓名等）用于后续履约服务。
                            </div>
                            <div class="content">
                                2.&nbsp;尚未勾选相关协议，为保证您的相关权益，请在购买前仔细阅读并同意相关规则
                                <span
                                    v-if="distributionId"
                                    @click="goDistributionProtocol"
                                    >《好课推荐付费内容消费者协议》</span
                                >
                                <span v-else @click="goUserProtocol"
                                    >《付费内容消费者用户协议》</span
                                >
                                <span @click="goUserInfoProtocol"
                                    >《个人信息授权协议》</span
                                >
                            </div>
                        </div>
                        <div v-else>
                            <div class="content">
                                尚未勾选相关协议，为保证您的相关权益，请在购买前仔细阅读并同意相关规则
                                <span
                                    v-if="distributionId"
                                    @click="goDistributionProtocol"
                                    >《好课推荐付费内容消费者协议》</span
                                >
                                <span v-else @click="goUserProtocol"
                                    >《付费内容消费者用户协议》</span
                                >
                            </div>
                        </div>
                    </template>
                </BoughtNoticeDialog>
                <!-- 同意协议的弹窗，当点击购买课（或是单节课）按钮的时候，如果用户没有勾选同意协议，则弹出此弹窗，这里是针对非站外履约课的  -->
                <BoughtNoticeDialog
                    v-model="boughtNoticePopupShow"
                    title="温馨提示"
                    confirm-txt="同意并提交"
                    @agree="
                        boughtNoticePopupShow = false;
                        agreeProtocol();
                    "
                >
                    <template #content>
                        <div class="content">
                            尚未勾选相关协议，为保证您的相关权益，请在购买前仔细阅读并同意相关规则
                            <span
                                v-if="distributionId"
                                @click="goDistributionProtocol"
                                >《好课推荐付费内容消费者协议》</span
                            >
                            <span v-else @click="goUserProtocol"
                                >《付费内容消费者用户协议》</span
                            >
                            。
                        </div>
                    </template>
                </BoughtNoticeDialog>
                <!--  分销申请确认弹窗  -->
                <Confirm
                    v-if="distributionConfirmFlag"
                    :title="'是否确认进行好课推荐'"
                    :ok-disabled="!distributionProtocolFlag"
                    class="distribution-confirm"
                    @ok="distributionConfirmOk"
                    @cancel="distributionCancel"
                >
                    <template #content>
                        <div class="distribution-confirm-layout">
                            <p class="distribution-confirm-layout-writer">
                                1.实际收入=实际成交价*佣金比例
                            </p>
                            <p class="distribution-confirm-layout-writer">
                                2.结算收入=实际收入*平台抽佣比例
                            </p>
                            <DistributionProtocol
                                v-model="distributionProtocolFlag"
                            ></DistributionProtocol>
                        </div>
                    </template>
                </Confirm>
                <!--  分销申请成功弹窗  -->
                <ComBottomDialog
                    v-model="distributionConfirmSuccessFlag"
                    :icon-name="'//p4-plat.wskwai.com/kos/nlav12662/cdn_image/accomplish.png'"
                    :title="'好课推荐成功'"
                    :btns="distributionConfirmSuccessBtns"
                    :size="'small'"
                >
                    <template #content>
                        <div style="text-align: center">
                            您可以在
                            <span style="color: #000; font-weight: 500">
                                「付费内容-赚佣金-推荐管理-我推荐的」
                            </span>
                            下查看内容。
                        </div>
                    </template>
                </ComBottomDialog>
                <!---  当点击BoughtNoticeDialog的同意并提交按钮，会弹出次弹窗，这个弹窗是填写学员信息的（站外履约课）  --->
                <OffSiteStudentInfoDialog
                    :visible="offSiteStudentInfoDialogShow"
                    :course-id="courseId"
                    :seller-id="teacherUid"
                    :commodity-id="commodityId"
                    :has-name="orderInfo.includes('NAME')"
                    :is-financial-qualification="
                        dataCourse?.isFinancialQualification
                    "
                    :course-customer-info="courseCustomInfo"
                    @close="offSiteStudentInfoDialogShow = false"
                    @success="offSiteStudentInfoSubmitSucess"
                ></OffSiteStudentInfoDialog>
                <!-- 交易面板，这面板会包含交易信息，然后再会跳到收银台或是快币充值面板 -->
                <PayCounterDialog
                    :visible="showPayCounterDialog"
                    :is-paying="isPaying"
                    :nonage="nonage"
                    :model="model"
                    :name="product.name"
                    :price="product.price"
                    :origin-price="product.originPrice"
                    :discount="product.discount"
                    :user-balance="userBalance"
                    :use-kscoin-pay="useKscoinPay"
                    :vouchers="product.vouchers"
                    :course-id="product.courseId"
                    :lesson-id="product.lessonId"
                    @pay="payByKsCoin(product.lessonId, $event)"
                    @close="hidePayCounterDialog"
                ></PayCounterDialog>
                <!-- 当是快币支付方式的时候，余额不足要拉起充值面板，这个就是充值面板 -->
                <KsCoinIapListDialog
                    v-if="showKsCoinIapListLayer"
                    class="pay-counter"
                    :ks-coin-iap-list="ksCoinIapList"
                    :ks-coin="product.price"
                    :user-balance="userBalance"
                    :is-refreshing="isRefreshingBalance"
                    @refresh-balance="refreshBalance"
                    @charge-success="chargeSuccess"
                    @charge-fail="chargeFail"
                    @close="hideKsCoinIapListLayer"
                ></KsCoinIapListDialog>
                <!-- 站外履约课购买成功后的交互弹窗 -->
                <ComBottomDialog
                    v-model="offsiteBoughtSuccessVisible"
                    :title="'温馨提示'"
                    :btns="offsiteBoughtSuccessBtns"
                >
                    <template #content>
                        <div class="offsite-bought-success-dialog">
                            <div
                                v-if="receiveLinkUrl || receiveQrcodeUrl"
                                class="content first"
                            >
                                1.&nbsp;本课程<span>不在快手app上学习和观看。</span>请根据<span>课程领取提示</span>主动联系课程老师安排后续上课事宜。
                            </div>
                            <div v-else class="content first">
                                1.&nbsp;本课程<span>不在快手app上学习和观看。</span>请保持电话畅通，关注短信提醒，<span
                                    >耐心等待您购买课程的老师主动联系安排后续上课事宜。</span
                                >
                            </div>
                            <div class="content second">
                                2.&nbsp;您可通过<span>「侧边栏-更多-付费内容-我购买的」</span>查看您所购买的课程。
                            </div>
                        </div>
                    </template>
                </ComBottomDialog>
                <!-- 用户评价该课程的面板, 由于这里是改版时候没有出ui图，复用的老样式，所以直接用了老代码，以后应该把他封装成组件 -->
                <BottomLayer
                    :show="showEvaluateDialog"
                    @hide-layer="cancelEvaluate"
                >
                    <template #content>
                        <div class="evaluate-wrap">
                            <div class="e-title">
                                {{
                                    isOffSiteCourseFlag
                                        ? `这个课程体验怎么样`
                                        : `你对这个精选课程感觉怎么样`
                                }}
                            </div>
                            <img
                                class="icon-close"
                                src="./img/close2.png"
                                @click="cancelEvaluate"
                            />
                            <div :class="{ 'is-oppo-wrap': isOppoWrap }">
                                <!-- 选择不满意 还行 很棒 -->
                                <div class="e-select">
                                    <div
                                        v-for="(
                                            item, index
                                        ) in courseEvaluateList"
                                        :key="item.value"
                                        class="e-item"
                                        :index="index + 1"
                                        :class="{
                                            active: evaluate === item.value,
                                        }"
                                        @click="selectEvaluate(item)"
                                    >
                                        <img
                                            class="e-i-img"
                                            :src="
                                                evaluate === item.value
                                                    ? item.activeImg
                                                    : item.img
                                            "
                                        />
                                        <div class="e-i-label">
                                            {{ item.label }}
                                        </div>
                                    </div>
                                </div>
                                <!-- 当选择不满意的时候，展示下面的不满意选择标签 -->
                                <div
                                    v-show="evaluate === 'UNSATISFIED'"
                                    class="evaluate-tags"
                                >
                                    <div
                                        v-for="(tag, index) in evaluateTags"
                                        :key="tag"
                                        class="e-tag"
                                        :index="index + 1"
                                        :class="{
                                            active:
                                                selectedEvaluateTags.indexOf(
                                                    tag,
                                                ) !== -1,
                                        }"
                                        @click="selectEvaluateTag(tag)"
                                    >
                                        {{ tag }}
                                    </div>
                                    <div class="e-tag-last"></div>
                                </div>
                                <!-- 填写评价的文本框 -->
                                <div class="e-content">
                                    <textarea
                                        v-model="evaluateContent"
                                        class="e-content-textarea"
                                        placeholder="（选填）说说优点或不足，可匿名填写"
                                        maxlength="200"
                                        autocomplete=""
                                    >
                                    </textarea>
                                    <div class="e-content-word-limit">
                                        <span class="">{{
                                            evaluateContent.length
                                        }}</span
                                        >/200
                                    </div>
                                </div>
                                <!-- 提交按钮 -->
                                <div
                                    class="submit-btn"
                                    :class="{
                                        disabled: isEvaluating || !evaluate,
                                    }"
                                    @click="submitEvaluate"
                                >
                                    提交
                                </div>
                            </div>
                        </div>
                    </template>
                </BottomLayer>
                <!-- 评论成功 -->
                <EvaluateSuccess
                    v-if="evaluateSuccessFlag"
                    :data-recommend-list="dataRecommendList"
                    :data-recommend-more="dataRecommendMore"
                    :evaluate="evaluate"
                    :data-teacher-info="dataTeacherInfo"
                ></EvaluateSuccess>
                <!-- 挂件 -->
                <Pendant></Pendant>
            </template>
            <ReceiveTypePop
                v-model="receivePopShow"
                :link-url="receiveLinkUrl"
                :qrcode-url="receiveQrcodeUrl"
                :title="dataCourseFirst?.name"
                :teacher="dataTeacherInfo?.name"
                @change="changeReceiveType"
            ></ReceiveTypePop>
            <ComBottomPanel
                v-model="distributionDialogVisable"
                :title="'温馨提示'"
                :btns="distributionDialogBtns"
            >
                <template #content>
                    <div style="text-align: center">
                        使用该功能需要您同时完成微信和支付宝授权绑定，否则无法开启推荐。账号一经绑定无法修改。
                    </div>
                </template>
            </ComBottomPanel>
        </div>
    </PageLoadComponent>
</template>
<script setup lang="ts">
import { initLogBridge, pushLogBridge } from '@/utils/weblog-bridge';
import { Toast, ActivityIndicator } from '@lux/sharp-ui-next';
import '@lux/sharp-ui-next/themes/default/toast';
import '@lux/sharp-ui-next/themes/default/activity-indicator';
import {
    ref,
    computed,
    provide,
    nextTick,
    onBeforeUnmount,
    defineAsyncComponent,
    onMounted,
} from 'vue';
import { openOrDownload } from '@ks/web-util/open-app';
import share from '@/utils/share';
import PageLoadComponent from '@/components/page-load/index.vue';
import Cover from './components/Cover.vue';
import Equity from './components/Equity.vue';
import Info from './components/Info.vue';
import AboutSku from './components/AboutSku.vue';
import Marquee from '../../../kt-components/Marquee/index.vue';
import { BottomDialogFooterBtn } from '@lux/sharp-ui-next/types/component/bottom-dialog/type';
import { isHarmony } from '@/utils/utils';
const Bundle = defineAsyncComponent(() => import('./components/Bundle.vue'));
// 站外课兑现链接or兑现二维码
const ReceiveTypePop = defineAsyncComponent(
    () => import('./components/ReceiveTypePop.vue'),
);
const Agreement = defineAsyncComponent(
    () => import('./components/Agreement.vue'),
);
// 老师信息模块
const Teacher = defineAsyncComponent(() => import('./components/Teacher.vue'));
// 课程介绍模块
const Introduce = defineAsyncComponent(
    () => import('./components/Introduce.vue'),
);
// 导航条
const Nav = defineAsyncComponent(() => import('./components/Nav.vue'));
// 吸底按钮条
const BottomBar = defineAsyncComponent(
    () => import('./components/BottomBar.vue'),
);
// 课节部分
const Lesson = defineAsyncComponent(() => import('./components/Lesson.vue'));
// 评价信息模块
const Comment = defineAsyncComponent(() => import('./components/Comment.vue'));

// 评价入口
const Evaluate = defineAsyncComponent(
    () => import('./components/Evaluate.vue'),
);
// 客服
const MyCustomer = defineAsyncComponent(
    () => import('./components/MyCustomer.vue'),
);

// 评价面板，复用老的组件
const BottomLayer = defineAsyncComponent(
    () => import('@/components/BottomLayer/Index.vue'),
);
// 优惠券的弹窗
const VoucherPopup = defineAsyncComponent(
    () => import('./components/VoucherPopup.vue'),
);
// 挂件
const Pendant = defineAsyncComponent(
    () => import('@/components/Pendant/index.vue'),
);
// 直播课报名的观众
const SignUp = defineAsyncComponent(() => import('./components/SignUp.vue'));
// 去广场按钮
const SquareBtn = defineAsyncComponent(
    () => import('./components/SquareBtn.vue'),
);
// 物流信息
const FastMail = defineAsyncComponent(
    () => import('./components/FastMail.vue'),
);
// 同意协议弹窗
const BoughtNoticeDialog = defineAsyncComponent(
    () => import('./components/common/BoughtNoticeDialog.vue'),
);
// 未进件时不能进行分销底部面板弹窗提醒
const ComBottomPanel = defineAsyncComponent(
    () => import('./components/common/ComBottomPanel.vue'),
);
// 分销申请成功弹窗、站外履约课购买成功的弹窗
const ComBottomDialog = defineAsyncComponent(
    () => import('./components/common/ComBottomDialog.vue'),
);
// 这个是交易面板（包含信息如优惠券、快币余额），在购课前会先唤起这个组件，如果快币支付余额不足会再唤起快币充值面板
const PayCounterDialog = defineAsyncComponent(
    () => import('@/components/comsume/PayCounterDialog/index.vue'),
);
// 站外履约课填写学员信息弹窗组件
const OffSiteStudentInfoDialog = defineAsyncComponent(
    () => import('@/components/comsume/OffSiteStudentInfoDialog/index.vue'),
);
// 快币充值面板弹窗
const KsCoinIapListDialog = defineAsyncComponent(
    () => import('@/components/comsume/KsCoinIapListDialog.vue'),
);
const EvaluateSuccess = defineAsyncComponent(
    () => import('./components/EvaluateSuccess.vue'),
);
// 复购 同作者推荐
const Reapeat = defineAsyncComponent(() => import('./components/Reapeat.vue'));
// 复购 不同作者推荐
const Recommend = defineAsyncComponent(
    () => import('./components/Recommend.vue'),
);
// 推荐分销确认弹窗
const Confirm = defineAsyncComponent(
    () => import('./components/common/Confirm.vue'),
);
// 确认分销弹窗里面的协议
const DistributionProtocol = defineAsyncComponent(
    () => import('./components/DistributionProtocol.vue'),
);
// 赠品说明
const Gift = defineAsyncComponent(() => import('./components/Gift.vue'));
// 充电节活动（2025.5.26-2025.6.8）0元抢大额券 瓜分快手红包
const Coupon = defineAsyncComponent(() => import('./components/Coupon.vue'));
// yoda
import {
    invoke,
    isInYoda,
    showConfirmDialog,
    showAlertDialog,
    addListener,
    removeListener,
} from '@/yoda';
// 获取登录状态插件
import { checkLogin } from '@/utils/login';
// 是否是急速版，是否是安卓，比较客户端版本
import {
    isNebula,
    isAndroid,
    isIOS,
    compareVersionNew,
    compareVersionByOs,
    kpn,
    iosDoubleCheck,
} from '@/utils/env';
// 用于判断当前客户端是否支持试看、用户反馈路径
import {
    kwaiAppVersion,
    feedbackUrl,
    courseEvaluateList,
    CourseEvaluateItem,
    DISTRIBUTION_BIND_URL,
    officialKsUid,
    isLiveCourse,
    isOffSiteCourse,
    isVideoCourse,
    isFreeVideoCourse,
    isOfflineCourse,
    isPackageCourse,
    getCourseTypeLabel,
} from '@/constant/index';
// 滑动动作 去看视频课程、账号冻结提示、更新或是打开快手app、
import {
    setSlideBack,
    toVideo,
    showAccountExceptionDialog,
    openOrDownloadKsApp,
} from '@/utils/index';
// 从cookie里去拿ui信息 或是客户端信息
import { getCookie } from '@/utils/cookie';
// 1和2分别是支付单节课程和支付整个课(支付中台)，3是确认购买完后是否有对应的权益（课节）4是是确认购买完后是否有对应的权益（这个课）5不确定是干嘛用的，历史保留下来的
import {
    payForCourse,
    payForLesson,
    checkPayLesson,
    checkPayCourse,
    setSettingEntryForCourse,
    setContainerStatus,
    getContainerStatus,
} from '@/utils/pay';
import { openPayCounter, isRNPaySupported } from '@/utils/rn-pay-bridge';

import { getLiveUrl, getUrlParam, Goto } from '@/utils/url';
import { makeActionLog } from './log';
import { getServerExpTag } from '@/utils/exptag';
import {
    LoadingState,
    sendFMP,
    reportCustomEvent,
    reportTransformEventEnd,
    reportTransformEventStart,
    radar,
} from '@/utils/const';
import {
    getCourseDetail,
    getTradeInfo,
    getUserRole,
    getDetailEvaluation,
    getTeacherInfo,
    CourseDetail,
    CourseDetailCourse,
    CourseDetailTags,
    CourseDetailGifts,
    UserRole,
    GiftDeliveryInfo,
    CourseDetailLessons,
    DetailEvaluation,
    TeacherInfo,
    TradeInfo,
    VoucherList,
    CourseTradeInfo,
    TradeInfoLessonTradeInfoMap,
    getOrderPrepayInfo,
    getKsCoinIapList,
    KsCoinIapItem,
    ProductType,
    followUserByApi,
    unsubscribeFreeCourse,
    subscribeFreeCourse,
    getInviteTaskState,
    TaskState,
    getCourseEvaluationStatus,
    evaluateCourse,
    receiveCoupons,
    delNotice,
    RecommendList,
    RecommendMore,
    getRecommendList,
    getCourseBrief,
    getCustomerServiceMerchantId,
    CourseDetailDistribution,
    getDistributionStatus,
    MyDistributionStatus,
    getDistributorBindInfo,
    fixApplyDistribution,
    getDistributorInfo,
    getContentAcquisition,
    heroAndPowerInfo,
    userForwardTaskAward,
} from './service';
import { followUser } from '@/utils/follow';
import { request } from '@/services';

// 广告主信息
const corporationName = getUrlParam('adCorporationName') || '';
// 商业化投流广告主的名字
const adCorporationName = ref<string>(decodeURIComponent(corporationName));
// 获取url中的课程id，请求课程信息会用
const courseId = (location.pathname.match(/\d+/g) || []).join('');
// 是否直接展示评论
const mountedShowComment = getUrlParam('showComment') || '';
// 获取url中的帮卖者id
const distributionId = getUrlParam('distributionId') || '';
// 代表渠道
const channel = getUrlParam('channel') || '';
// 记录页面的来源，从哪个页面跳过来的，这里主要是记录是否从帮卖广场过来
const from = getUrlParam('from') || '';
// 控制loading
const isLoading = ref<number>(LoadingState.idle);
// 用于存取首屏课程详细信息
const dataCourseFirst = ref<CourseDetailCourse>();
// 用于存取课程详细信息
const dataCourse = ref<CourseDetailCourse>();
// 课程类型判断（唯一收口，判断时优先取 packageType，通过 provide 向下传递）
const effectiveCourseType = computed(
    () => dataCourse.value?.packageType || dataCourse.value?.courseType,
);
const isLiveCourseFlag = computed(() =>
    isLiveCourse(effectiveCourseType.value),
);
const isOffSiteCourseFlag = computed(() =>
    isOffSiteCourse(effectiveCourseType.value),
);
const isVideoCourseFlag = computed(() =>
    isVideoCourse(effectiveCourseType.value),
);
const isFreeVideoCourseFlag = computed(() =>
    isFreeVideoCourse(effectiveCourseType.value),
);
const isOfflineCourseFlag = computed(() =>
    isOfflineCourse(effectiveCourseType.value),
);
const courseTypeLabel = computed(() =>
    getCourseTypeLabel(effectiveCourseType.value),
);

// 打包课只判断 courseType
const isPackageCourseFlag = computed(() =>
    isPackageCourse(dataCourse.value?.courseType),
);
// 向子/孙组件传递课程类型判断（子组件 inject 后直接用布尔值，无需再判断 courseType）
provide('isLiveCourseFlag', isLiveCourseFlag);
provide('isOffSiteCourseFlag', isOffSiteCourseFlag);
provide('isVideoCourseFlag', isVideoCourseFlag);
provide('isFreeVideoCourseFlag', isFreeVideoCourseFlag);
provide('isOfflineCourseFlag', isOfflineCourseFlag);
provide('isPackageCourseFlag', isPackageCourseFlag);
provide('courseTypeLabel', courseTypeLabel);
// 用于存取是否为新营销课程
const isNewMarketingCourse = ref<boolean>(false);

const shouldShowUpdateTip = computed(() => {
    const kConfConfig = window['kConf_platecoDev.lightks.upgradeTip'];
    const showUpgradeTip = kConfConfig?.showUpgradeTip || false;
    const qualificationType = dataCourse.value?.qualificationType;
    return showUpgradeTip && qualificationType === 22;
});
const showSellStatus = computed(() => {
    const sellStatus = dataCourse.value?.courseSellStatus;
    return !sellStatus || sellStatus === 'NORMAL';
});
/** **************************************************************************************************************
 * 以下这里存放的是一些数据的变量or常量
 ****************************************************************************************************************/
const showFlag = ref(false);
// model数据，这里主要是用于赠品
const model = ref({
    gifts: [] as CourseDetailGifts[],
});
// 物流信息list：物流公司 & 物流订单号
const deliveryInfoList = ref<GiftDeliveryInfo[]>([]);
// 老师的id单独拿出来，站外课填写信息会用得到
const teacherUid = ref(-1);
// 快币收银台是否在支付中
const isPaying = ref(false);
// 是否未成年
const nonage = ref<boolean>(false);
// 商品的id，用于交易的，他可能是整个课维度的，也有可能是某一个课节维度的，根据用户的购买状况去取
const commodityId = ref<number | null>();
// 控制评价弹窗
const showEvaluateDialog = ref(false);
// 控制在支付前唤起交易面板的开关，交易面板包括快币余额、优惠券信息等
const showPayCounterDialog = ref(false);
// 用于控制站外履约课||赠品课购买时候提醒用户同意协议的弹窗
const offSiteBoughtNoticePopupShow = ref(false);
// 用于控制!(站外外履约课||赠品课)购买时候提醒用户同意协议的弹窗
const boughtNoticePopupShow = ref(false);
// 用于控制站外履约课购买成功的提示弹窗是否展示
const offsiteBoughtSuccessVisible = ref(false);
const offsiteBoughtSuccessOk = () => {
    offsiteBoughtSuccessVisible.value = false;
};
const offsiteBoughtSuccessBtns = ref<BottomDialogFooterBtn[]>([
    {
        text: '我知道了',
        type: 'plain',
        handler: offsiteBoughtSuccessOk,
    },
]);
// 用于控制站外履约课-学员信息填写弹窗是否展示
const offSiteStudentInfoDialogShow = ref(false);
// 用于记录学员在购买站外履约课的时候是否填写完了个人信息
const offSiteStudentInfoDialogDone = ref(false);
// 控制快币充值弹窗的开关
const showKsCoinIapListLayer = ref(false);
// 控制优惠券下发的弹窗开关（如果用户有未领取的优惠券）
const voucherPopupFlag = ref(false);
// 控制导航条是否展示flag
const navFlag = ref(true);
// 控制导航条的透明度
const navOpacity = ref(0);
// 用于记录导航条应该选中那个模块，根据滚动的位置状态去区分
const navSelected = ref('');
// 记录是否是点击导航条触发的滚动
const navActionClick = ref(false);
// 用于在购买单个课节时，暂时存放响应的课节信息，因为在购买的流程中要判断很多的状态，执行多个方法后才会走到最后的支付（支付需要课节的商品id，商品id要用课节的id去相应的Map中拿），所以声明这个变量暂时存放选中课节信息
const lesson = ref<CourseDetailLessons | undefined>();
// 这个东西是啥之后再补充，在老逻辑里提出来的，目前没看懂,似乎是代表充值面板的一种状态，和css样式有关
const isRefreshingBalance = ref<boolean>();
// 用户的账户余额数，会在拉起支付面板前获取
const userBalance = ref<number>(0);
// 用户的账户状态，会在拉起支付面板前获取
const userStatus = ref<number>();
// 用户的账户状态是否被禁用，这里是根据订单支付接口获取的，这个是‘消费者’是否异常，isBanned是根据老师接口取出来的，判断的是‘老师’是否存在异常，注意区分！！！！
const userBanned = ref<boolean>();
// 当前用户是否可以评价该课程
const canCourseEvaluate = ref<boolean>(false);
// 用户多少天后可以评论
const restDays = ref(0);
// 课的销量，离线数据
const subscriberCount = ref(0);
// 用于存放处理过的销量数据，用于页面展示
const displaySubscriberCount = ref<string>('');
// 用于存放处理过的剩余销量数据，用于页面展示
const displaySoldInfoStr = ref<string>('');
// 用于存放站外履约课需要用户填写的自定义信息
const courseCustomInfo = ref<Record<string, string[]>>({});
// 用于存取权益
const dataTags = ref<CourseDetailTags[]>([]);
// 用于存取用户角色相关的信息
const dataUserRole = ref<UserRole>();
// 是否快币支付，支付方式分为快币和人民币，这个变量单独取出来
const useKscoinPay = ref<boolean>();
// 站外履约课弹窗用的orderInfo，具体做啥用的不清楚，保留下来的历史逻辑
const orderInfo = ref<string[]>([]);
// 用于存取课节的数组
const dataLessons = ref<CourseDetailLessons[]>([]);
// 用于判断直播课是否可以试看的
const dataCanLiveTrial = ref<boolean>();
// 用于存取用户评论信息
const dataEvaluation = ref<DetailEvaluation>();
// 用于存取老师的相关信息
const dataTeacherInfo = ref<TeacherInfo>();
// 用于存取赠品课
const dataGifts = ref<CourseDetailGifts[]>([]);
// 用于存取用户未领取的优惠券数组
const voucherList = ref<VoucherList[]>([]);
// 用于存放直播课最近的一节课
const nearestLesson = ref<CourseDetailLessons>();
// 课程交易的相关信息
const courseTradeInfo = ref<CourseTradeInfo>();
// 控制同意协议
const myProtocolFlag = ref(false);
// 同意关注
const agreeFollow = ref(false);
// 控制帮卖/分销/推荐协议
const distributionProtocolFlag = ref(false);
// 课节相关额详细
const lessonTradeInfoMap =
    ref<Record<string | number, TradeInfoLessonTradeInfoMap>>();
// 其他作者推荐是否已经展示
const showRecommend = ref(false);
// 客服跳转的merchantId
const customerServiceMerchantUrl = ref('');
// 捆绑课列表
const bundleList = ref([]);
// 课程帮卖/分销/推荐信息的相关信息
const dataCourseDistribution = ref<CourseDetailDistribution>();
// 课程帮卖信息的相关状态
const dataMyDistributionStatus = ref<MyDistributionStatus>();
/// 帮卖/分销/推荐者的名字
const distributorName = ref('');
// 赠品的名字
const giftsName = ref('');
// 赠品的图片
const giftImgUrls = ref<string[]>([]);
// 站外课兑现弹框
const receivePopShow = ref(false);
// 未进件不能进行分析提醒弹窗
const distributionDialogVisable = ref(false);
// 未进件不能分销的两个按钮
const distributionDialogCancel = () => {
    distributionDialogVisable.value = false;
};
// feed上下滑分页
const dataPageSize = ref(0);
const dataFeedView = ref(false);
const distributionDialogConfirm = () => {
    Goto(DISTRIBUTION_BIND_URL, {}, true);
    distributionDialogVisable.value = false;
};
const distributionDialogBtns = ref<BottomDialogFooterBtn[]>([
    {
        text: '我知道了',
        type: 'plain',
        handler: distributionDialogCancel,
    },
    {
        text: '去配置',
        type: 'primary',
        handler: distributionDialogConfirm,
    },
]);
// 站外课兑现链接
const receiveLinkUrl = ref('');
// 站外课兑二位码地址
const receiveQrcodeUrl = ref('');
// 购买后的弹窗控制, 如果是刚购买的站外课, 通过这个字段决定履约弹屏和用户隐私政策的先后弹
const isBuySuccessFlag = ref(false);
// RN 支付降级开关：true = 使用 RN 支付，false = 使用 H5 支付
const useRNPay = ref(false);
/**
 * 页面初始化调用
 */
async function fetchInitPage(isLoad?: any) {
    /**
     * 请求获取课程相关信息，例如标题、封面、课程分集
     * 获取商品的价格等交易信息
     * 用于判断当前用户角色相关信息
     * 获取用户是否可以发表评论相关
     * 获取联系商家方式
     * 获取分销状态
     */
    const [res1, res2, res3, res4, res5] = await Promise.all([
        getCourseDetail({
            courseId: courseId,
            courseDistributionId: distributionId,
            channel,
        }),
        getTradeInfo({
            courseId: courseId,
            courseDistributionId: distributionId,
        }),
        getUserRole(courseId),
        getCourseEvaluationStatus(Number(courseId)),
        getDistributionStatus(courseId),
    ]);
    const resData1 = res1.data as CourseDetail;
    if (isPackageCourse(resData1.course.courseType)) {
        const _dataLessons =
            resData1.coursePackages
                .map((item: any) => item.lessons)
                .flat()
                .sort(
                    (a: any, b: any) =>
                        (a.scheduledStartTime || 0) -
                        (b.scheduledStartTime || 0),
                ) || [];
        // 覆盖原字段
        resData1.course.lessonCount = _dataLessons.length;
        // 强制使用合并的课节逻辑
        dataLessons.value = _dataLessons || [];
    } else {
        // lessons包含课节的相关信息，详细看CourseDetailLessons断言
        dataLessons.value = resData1.lessons || [];
    }
    // course包含课程的相关信息，详细看CourseDetailCourse断言
    dataCourse.value = resData1.course;
    // 打包课
    bundleList.value = resData1.coursePackages || [];
    // tags包含权益相关信息，详细看CourseDetailTags断言
    dataTags.value = resData1.tags;
    // gifts包含赠品课信息，详细看CourseDetailGifts断言
    dataGifts.value = resData1.gifts;
    // canLiveTrial代表如果是直播课是否可以试看
    dataCanLiveTrial.value = resData1.canLiveTrial;
    // feed上下滑分页
    dataPageSize.value = resData1.pageSize || 0;
    dataFeedView.value = resData1.feedView || false;
    // 用于记录赠品，主要是给交易面板使用的
    model.value.gifts = resData1.gifts;
    // 直播课最近的一节课，传给底部按钮使用
    nearestLesson.value = resData1.nearestLesson;
    // 课堂离线销量
    subscriberCount.value = resData1.subscriberCount;
    displaySubscriberCount.value = resData1.displaySubscriberCount;
    // 站外履约课用户需要自定义选择的变量
    courseCustomInfo.value = resData1.courseCustomInfo || {};
    // orderInfo是给站外履约课弹窗用的
    orderInfo.value = resData1.course.orderInfo || [];
    // 帮买/分销/推荐先关信息
    dataCourseDistribution.value = resData1.courseDistribution || {
        canDistribute: false,
        commissionMaxPrice: 0,
        commissionMinPrice: 0,
        commissionRate: 0,
    };
    // 判断赠品
    if (resData1.gifts.length > 0) {
        giftsName.value = resData1.gifts[0].name;
        giftImgUrls.value = resData1.gifts[0].giftImgUrls;
    }
    isNewMarketingCourse.value = resData1.course.isNewMarketingCourse || false;
    // 只有新营销默认勾选
    if (isNewMarketingCourse.value) {
        agreeFollow.value = true;
    }
    // 获取tradeInfo
    const resData2 = (res2.data as TradeInfo) || {
        voucherList: [],
        courseTradeInfo: {},
        lessonTradeInfoMap: {},
    };
    displaySoldInfoStr.value = resData2.courseTradeInfo?.displaySoldInfoStr;
    // voucherList 包含用户未领取的优惠券信息（如果还有券可以领取的话）
    voucherList.value = resData2.voucherList;
    // courseTradeInfo交易的相关信息
    courseTradeInfo.value = resData2.courseTradeInfo;
    // lessonTradeInfoMap 包含的是课节相关的东西
    lessonTradeInfoMap.value = resData2.lessonTradeInfoMap;
    // 如果有未领取完的优惠券，则展示领取弹窗
    if (voucherList.value.length > 0 && isLoad) {
        voucherPopupFlag.value = true;
    }
    // 获取UserInfo
    const resData3 = res3.data as UserRole;
    dataUserRole.value = resData3 as UserRole;

    useRNPay.value = isRNPaySupported();

    // 老 h5 安卓只有人民币支付，走快币会导致充值失败，iOS 或 鸿蒙 或 新版本 走后端控制
    useKscoinPay.value =
        isAndroid && !useRNPay.value ? false : resData3?.useKscoinPay;

    // 用户如果有权益的话，就去请求复购的接口
    if (resData3.hasAllCourseRight) {
        /**
         * 获取复购的数据
         */
        fetchRecommendList();
    }
    // 如果有物流信息
    if (resData3.giftDeliveryInfoList) {
        deliveryInfoList.value = resData3.giftDeliveryInfoList.filter(
            (item) => {
                const { deliveryCompany, deliveryOrderNo } = item || {};
                return deliveryCompany && deliveryOrderNo;
            },
        );
    }
    // 获取当前用户的评价状态
    // 是否展示课评论模块
    canCourseEvaluate.value = res4.evaluationStatus === 'TO_EVALUATION';
    // 多少天后可以评论
    restDays.value = res4.restDays;
    evaluateTags.value = res4.badEvaluationConfig;
    if (
        canCourseEvaluate.value &&
        (restDays.value || 0) < 1 &&
        !localStorage.getItem(`EvaluationStatus${courseId}`)
    ) {
        // 如果用户可以评论，第一次进来默认拉起评论面板
        showEvaluateDialog.value = true;
        localStorage.setItem(`EvaluationStatus${courseId}`, '1');
    }
    // 异步获取客服跳转的merchantId，不阻塞首屏
    // 版本号 >= 14.6.10 才请求接口展示客服入口
    if (compareVersionByOs(kwaiAppVersion[kpn].allowCustomerService) <= 0) {
        void getCustomerServiceMerchantId(courseId).then((res: any) => {
            customerServiceMerchantUrl.value = res?.data
                ? `kwai://chat/session?sessionId=${
                      res.data
                  }&sessionType=0&subbiz=PAID_FEATURED&pageStyle=1&subbizContext=${JSON.stringify(
                      { courseId },
                  )}&chatPageSource=COURSE_DETAIL_V2`
                : '';
        });
    }
    // 获取当前用户帮卖状态
    dataMyDistributionStatus.value = res5.data as MyDistributionStatus;
    // 如果是帮卖者/分销者/推荐者商详页，则展示帮卖
    if (distributionId) {
        void getDistributorInfo(distributionId, courseId).then((res) => {
            distributorName.value = res.data?.distributorName;
        });
    }
    if (isLoad === true) {
        myProtocolFlag.value = !resData3.needAgreePurchaseAgreement;
        // 获取其他信息
        void fetchOthers();
        void nextTick(() => {
            fixPageScroll();
            window.scrollTo(0, 0);
        });
        // 获取到主主接口信息，直接处理分享相关的以及页面tile
        setPageText();
        if (isInYoda) {
            void addListener(
                'native_reentry', // 页面切换回来刷新详情
                fetchInitPage,
            );
            void addListener(
                'operation-paid-content-refresh-page', // 客户端通知刷新页面数据
                fetchInitPage,
            );
            // 七分屏适配, 业务场景报错兜底
            fixSevenScreen().catch((err) => {
                console.log(err, ' <== err');
            });
        }
    }
}
// 站外课领取权益功能,点击后会弹出领取二维码和链接
const handleReceive = async () => {
    const res: any = await getContentAcquisition(courseId);
    if (res && res.result === 1) {
        receivePopShow.value = true;
        const {
            contentAcquisitionMode,
            qrCodeImgKeys,
            qrCodeImgUrls,
            contentAcquisitionURL,
        } = res.data;
        if (contentAcquisitionMode === 1) {
            receiveLinkUrl.value =
                (contentAcquisitionURL && contentAcquisitionURL[0]) || '';
            receiveQrcodeUrl.value = '';
            return;
        } else if (contentAcquisitionMode === 2) {
            receiveQrcodeUrl.value =
                (qrCodeImgUrls &&
                    qrCodeImgKeys &&
                    qrCodeImgUrls[qrCodeImgKeys[0]][0]) ||
                '';
            receiveLinkUrl.value = '';
            return;
        }
    } else {
        Toast.error('请联系客服');
    }
};
// 初始化页面请求
// fetchInitPage(true);
// 获取增长数据
const dataTask = ref<TaskState>();
// 用于存放快币充值面板数据
const ksCoinIapList = ref<KsCoinIapItem[]>([]);
// 用于存放购买商品的信息，用于生成订单以及支付
const product = ref<ProductType>({
    name: '',
    price: 0,
    originPrice: 0,
    discount: 0,
    vouchers: [],
    courseId: 0,
    lessonId: 0,
});
// Oppo这叠屏适配  内屏 宽699 高652
const isOppoWrap =
    window.screen.width > 600 &&
    window.screen.width / window.screen.height >= 0.9;
// 用于记录当前用户评价选择了那个满意程度
const evaluate = ref('');
// 用于存放差评下面的复选标签
const evaluateTags = ref<string[]>([]);
// 用于记录用户选择了哪些差评的标签
const selectedEvaluateTags = ref<string[]>([]);
// 用于记录用户评价填写了哪些信息
const evaluateContent = ref('');
// 是否是七分屏的形式换气的页面
const isSevenScreen = getUrlParam('layoutType') === '3';
// 七分屏的时候会用到这个，用于控制底部吸附按钮出现or消失
const bottomBarFlag = ref(1);
// 七分屏的时候会用到这个，用于控制底部吸附按钮距离底部的位置
const bottomBarDistance = ref('0px');
// 七分屏的时候会用到这个，七分屏的情况下，css是拿不到安全区域距离的，所以要手动写一个dom来做安全区域适配
const fixIosSevenFlag = ref(false);
// 七分屏的时候会用到这个，用于设置安全区域高度用的
const fixIosSevenHeight = ref('0px');
// 用于记录评价是否正在发送中
const isEvaluating = ref(false);
// 获取课程部分的元素
const ElementLesson = ref();
// 获取评理部分的元素
const ElementComment = ref();
// 获取评论部分的元素
const ElementIntroduce = ref();
// 获取导航条部分的元素
const ElementNav = ref();
// 获取其他作者推荐元素
const ElementRecommend = ref();
// 获取同意协议组件
const RefAgreement = ref();
// 记录当前页面的标题是详情还是课程名称 ，用于处理滚动过程中tiele的变化
let pagePos = '详情';
// 复购数据
const dataRecommendList = ref<RecommendList[]>([]);
// 复购作者更多数据
const dataRecommendMore = ref<RecommendMore>();
// 评价成功弹窗开关
const evaluateSuccessFlag = ref(false);
// 确认是否帮卖弹窗的开关
const distributionConfirmFlag = ref(false);
// 分销成功弹窗控制开关
const distributionConfirmSuccessFlag = ref(false);
/**
 * 好课推荐成功弹窗点击我知道了
 */
const distributionConfirmSuccessOk = () => {
    distributionConfirmSuccessFlag.value = false;
};
const distributionConfirmSuccessBtns = ref<BottomDialogFooterBtn[]>([
    {
        text: '我知道了',
        type: 'plain',
        handler: distributionConfirmSuccessOk,
    },
]);
const COURSE_OFFLINE_TIP_TEXT = computed(() => {
    if (isLiveCourseFlag.value) {
        return '该内容已下架，您仅可观看已购买的内容';
    }
    return '该课程已下架，您仅可观看您已购买的课集';
});
// 后面用于记录打点
let videoLog;
/**
 * 以下这里是一些页面的接口请求，以及信息的传递，页面初始化相关、以及页面拉起分享面板相关、还有fmp上报
 **********************************************************************************************************************/
/**
 * 绑定滚动事件
 */
const pageScroll = () => {
    // 这里要适配滚动条
    // 当窗口滚出这个高度的时候，nav将逐渐出现在屏幕中
    const overHeight = (window.innerWidth / 414) * 310;
    // 当窗口滚出这个高度的时候，nav的透明度变成1
    const overMaxHeight = overHeight + 60;
    // 计算出导航条的高度
    const navHeight = (window.innerWidth / 414) * 50;
    // 当时点击导航条触发的滚动时候，跳过下面的逻辑判断，会有样式问题
    // 滚动条滚动位置
    const scrollTop = document.documentElement.scrollTop;
    // 获取body的总长度
    const bodyHeight = document.body.scrollHeight;
    // 先处理页面标题
    if (scrollTop < 280) {
        if (pagePos !== '详情' && isInYoda) {
            invoke('webview.setPageTitle', { title: `详情` });
            pagePos = '详情';
        }
    }
    if (scrollTop > 280 && pagePos === '详情' && isInYoda) {
        invoke('webview.setPageTitle', {
            title: dataCourse.value?.name as string,
        });
        pagePos = dataCourse.value?.name as string;
    }
    if (window.innerHeight / bodyHeight > 0.6) {
        return;
    }
    if (scrollTop < overHeight) {
        // 滚条完全隐藏
        navFlag.value = false;
        // 透明度变成0
        navOpacity.value = 0;
    } else if (scrollTop > overHeight && overMaxHeight > scrollTop) {
        // 滚动条出现，并且透明度开始变化
        navFlag.value = true;
        navOpacity.value = (scrollTop - overHeight) / 70 + 0.1;
        // 清空导航条的选中状态
        navSelected.value = '';
    } else if (overMaxHeight < scrollTop) {
        navFlag.value = true;
        navOpacity.value = 1;
        // 判断用户滚动到了那个模块
        // 先判断课节, 如果页面有展示课节模块的话
        if (dataLessons.value.length > 1) {
            // 获取课节模块的位置，navActionClick.value这个不放在最上面判断是因为ios有bug
            void nextTick(() => {
                const pos = ElementLesson.value?.$el?.getBoundingClientRect();
                if (pos && Reflect.has(pos, 'top')) {
                    if (
                        pos.top < navHeight &&
                        pos.bottom > navHeight &&
                        !navActionClick.value
                    ) {
                        // 当课节在可视区域内，这选中lesson
                        navSelected.value = 'Lesson';
                        return;
                    }
                }
            });
        }
        // 判断一下评价是否出现在可视区域内
        if (
            dataEvaluation.value &&
            dataEvaluation.value &&
            dataEvaluation.value?.totalCount >=
                dataEvaluation.value?.showEvaluationMinCount
        ) {
            // 获取评论模块的位置，navActionClick.value这个不放在最上面判断是因为ios有bug
            void nextTick(() => {
                const posComment =
                    ElementComment.value?.$el?.getBoundingClientRect();
                if (posComment && Reflect.has(posComment, 'top')) {
                    if (
                        posComment.top < navHeight &&
                        posComment.bottom > navHeight &&
                        !navActionClick.value
                    ) {
                        // 当评论模块在可视区域内，这选中Comment
                        navSelected.value = 'Comment';
                        return;
                    }
                }
            });
        }
        // 判断一下介绍是否出现可可视区域内
        // 获取介绍模块的位置，navActionClick.value这个不放在最上面判断是因为ios有bug
        void nextTick(() => {
            const posIntroduce =
                ElementIntroduce.value?.$el?.getBoundingClientRect();
            if (posIntroduce && Reflect.has(posIntroduce, 'top')) {
                if (posIntroduce.top < navHeight && !navActionClick.value) {
                    // 当课节在可视区域内，这选中nav
                    navSelected.value = 'Introduce';
                    // return;
                }
            }
        });
        // 判断一下其他作者推荐模块是否已经展示
        if (showRecommend.value) {
            void nextTick(() => {
                if (
                    Reflect.has(
                        ElementRecommend.value?.$el || {},
                        'getBoundingClientRect',
                    )
                ) {
                    const posIntroduce =
                        ElementRecommend.value.$el.getBoundingClientRect();
                    if (posIntroduce.top < navHeight && !navActionClick.value) {
                        // 当课节在可视区域内，这选中相应的nav
                        navSelected.value = 'Recommend';
                        return;
                    }
                }
            });
        }
    }
    navActionClick.value = false;
};
/**
 * 页面滚动监听，处理一些和滚动相关的事件
 */
const fixPageScroll = () => {
    window.addEventListener('scroll', pageScroll);
};
/**
 * 解除监听
 */
const removePageScroll = () => {
    window.removeEventListener('scroll', pageScroll);
};
/**
 * 分享相关的方法，里面的一些参数去参考分享中台的文档
 */
const sharePage = async () => {
    const logo = 'https://p4-plat.wskwai.com/s1/archive/i/common/logo.png';
    const subBiz = isLiveCourseFlag.value
        ? 'LIVE_STREAM_COURSE'
        : 'PHOTO_COURSE';
    const landing = deepLink.value;
    const ud = getCookie('ud');
    const shareResourceType = isLiveCourseFlag.value ? 'BEFORE_LIVE' : '';
    const urlParams = new URLSearchParams(window.location.search);
    const shareFrom = urlParams.get('shareFrom');
    const options = {
        shareConfig: {
            subBiz,
            shareObjectId: ud,
            shareContent: 'KETANG',
            showSharePanel: true,
            shareResourceType,
            commonConfigs: {
                bizId: 22,
                shareUrl: landing,
                kwaiUrl: landing,
                bizFutureId: ud,
                source_share_user_id: ud,
                courseId,
                shareResourceType,
                distributionId: distributionId,
            },
            tokenStoreParams: {
                bizId: 22,
                shareUrl: landing,
                kwaiUrl: landing,
                actionButtonTargetUrl: landing,
                bigPicUrl: dataCourse.value?.coverImg ?? '',
                iconUrl: logo,
                actionButtonText: '去看看',
                bizFutureId: `${courseId}_${ud}`,
                source_share_user_id: ud,
            },
        },
        logOpt: { courseId },
        complete: () => {
            removeListener('native_share_dialog_event');
        },
    };
    await addListener('native_share_dialog_event', (e) => {
        if (e.eventId === 'user_select' && shareFrom === '2025HeroSecKill') {
            userForwardTaskAward(+courseId);
        }
    });
    share(options);
};
/**
 * 页面右上角icon设置分享动作,以及页面的title
 */
const setPageText = async () => {
    if (isInYoda) {
        if (!isHarmony) {
            void invoke('webview.setTopRightBtn', {
                show: true,
                icon: 'share',
                onClick: async () => {
                    await sharePage();
                },
            });
        }
        void invoke('webview.setPageTitle', { title: `详情` });
        setSlideBack(true);
        void invoke('ui.setTopBarStyle', {
            backgroundColor: '#ffffff',
            borderBottomColor: '#ffffff',
        });
    }
};
/**
 * 七分屏适配相关的逻辑处理，关于下面一写参数参考文档
 * https://docs.corp.kuaishou.com/k/home/VR2-H6nZE8mg/fcACLan3Sg2SY88HtYYsQrevD
 */
const fixSevenScreen = async () => {
    if (isSevenScreen) {
        // 隐藏titlebar
        void invoke('webview.hideNavigationBar');
        // 封装七分屏滚动事件
        const listener = function (data) {
            // 七分屏滑动的时候需要控制底部吸附按钮的位置与展示
            if (
                data.status == 1 ||
                data.status == 2 ||
                data.status == 4 ||
                data.status == 5
            ) {
                // 代表分滑动中的情况
                bottomBarFlag.value = 1;
                bottomBarDistance.value = `${
                    (data.rect.height +
                        data.rect.y -
                        data.availableSize.height) *
                    (window.innerWidth / data.rect.width)
                }px`;
            } else {
                bottomBarFlag.value = 0;
            }
            fixIosSevenFlag.value = false;
        };
        void addListener('tuna_cod_on_sliding_status_change', listener).then(
            (data) => {
                console.log(data);
            },
        );
        // 添加七分屏点击右上角icon事件监听，拉起分享面板
        const clickListener = async () => {
            await sharePage();
        };
        // 添加七分屏点击右上角事件
        void addListener('tuna_cod_on_icon_click', clickListener).then(
            (data) => {
                console.log(data);
            },
        );
        // 七分屏获取容器的当前状态，设置底部吸附按钮的位置
        getContainerStatus()
            .then((res) => {
                if (res.data) {
                    bottomBarFlag.value = 1;
                    bottomBarDistance.value = `${
                        (res.data.rect.height +
                            res.data.rect.y -
                            res.data.availableSize.height) *
                        (window.innerWidth / res.data.rect.width)
                    }px`;
                    // 七分屏唤起的时候css拿不到底部安全区域大小，需要手动设置
                    fixIosSevenFlag.value = true;
                    fixIosSevenHeight.value = `${
                        res.data.safeArea.bottom *
                        (window.innerWidth / res.data.rect.width) *
                        0.9
                    }px`;
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
};
/**
 * 在七分屏的情况下 点击底部按钮触发
 */
const fixSevenScreenBottomBtn = () => {
    // 拉起全屏模式
    try {
        if (isSevenScreen) {
            setContainerStatus();
        }
    } catch (error) {
        console.log(error, ' <== error');
    }
};
/**
 * 用于请求复购的数据
 */
const fetchRecommendList = () => {
    void getRecommendList(Number(courseId)).then(({ data }) => {
        const res = data as {
            recommendList: RecommendList[];
            recommendMore: RecommendMore;
        };
        dataRecommendMore.value = res?.recommendMore || ({} as RecommendMore);
        dataRecommendList.value = res?.recommendList || [];
    });
};

// 记录页面进入时间，用于计算各环节时长
const pageEnterTime = ref(0);

// 向孙组件深层传递，将用户信息传递给课节的按钮组件（components/lesson/Btn.vue）
provide('dataUserRole', dataUserRole);
// 向孙组件深层传递，将是否直播课是否可以试看递给课节的按钮组件（components/lesson/Btn.vue）
provide('dataCanLiveTrial', dataCanLiveTrial);
// 向孙组件深层传递，将组课程信息件传（components/lesson/Btn.vue）
provide('dataCourse', dataCourse);
// 向孙组件深层传递，将课程交易相关信息传递（components/lesson/Btn.vue）
provide('lessonTradeInfoMap', lessonTradeInfoMap);
// 向孙组件深层传递，是否用快币支付（components/lesson/Btn.vue）
provide('useKscoinPay', useKscoinPay);
// 向孙组件深层传递，页面进入时间
provide('pageEnterTime', pageEnterTime);
// 请求其他的业务接口
function fetchOthers() {
    /**
     * 获取该课程的评价
     * @courseId 课程id
     */
    void getDetailEvaluation(courseId).then(({ data }): void => {
        dataEvaluation.value = data as DetailEvaluation;
        void nextTick(() => {
            void nextTick(() => {
                window.scrollTo(0, 0);
            });
            // 如果存在这个hash值 就定位到评价模块
            setTimeout(() => {
                if (location.hash == '#comments') {
                    checkNavAction('Comment');
                }
            }, 1000);
        });
    });
    /**
     * 获取该课程的老师相关介绍信息
     * @courseId 课程id
     */
    void getTeacherInfo(courseId).then(({ data }): void => {
        dataTeacherInfo.value = data as TeacherInfo;
        teacherUid.value = dataTeacherInfo.value?.ksUid;
        void nextTick(() => {
            window.scrollTo(0, 0);
        });
    });
    /**
     * 增长业务，获取相关task数据
     */
    void getInviteTaskState(Number(courseId)).then(({ data }) => {
        dataTask.value = data as TaskState;
    });
}
/**
 * 连载课新增课程的时候，会有一个”新"字标签，再点击播放后，删除“新”字标签
 */
const fixDelNotice = (lessonId: number) => {
    void delNotice({
        noticePlace: 0,
        noticeRelatedId: `${lessonId}`,
    }).then(() => {
        fetchInitPage();
    });
};

/**
 * 以下是跳转、计算各种状态、与支付无关的等的业务场景
 *****************************************************************************************************************************/

// 控制是否展示去广场页入口
const showHomeEntry = computed(() => {
    const channel = getUrlParam('channel') || '';
    return ![
        'fromBought',
        'created',
        'newSquare2021',
        'newSquare2022',
        'squareFreeCourse',
        'detailOtherCourse',
        'homeCreated',
    ].some((item) => channel.endsWith(item));
});
// 分享唤起的deeplink
const deepLink = computed(() => {
    const distributionStr = distributionId
        ? `&distributionId=${distributionId}`
        : '';
    return `${location.origin}/detail/${courseId}?channel=fromDeeplink&hyId=vision${distributionStr}`;
});
// 是否是免费课
const isFreeCourse = computed(() => {
    return isFreeVideoCourseFlag.value || dataCourse.value?.free;
});
// 当前课程的‘老师账号’是否存在异常，这里是根据老师接口取出来的，userBanned是根据订单支付接口取出来的，代表的是当前‘消费者’账号是否异常，注意区分！！！！
const isBanned = computed(() => {
    return (
        dataTeacherInfo.value?.teacherBanStatus === 'USER_ONLY' ||
        dataTeacherInfo.value?.teacherBanStatus === 'USER_WITH_CONTENT'
    );
});
// 是否有可以使用的优惠券
const canDiscount = computed(() => {
    return !!courseTradeInfo.value?.recommendedCombinationVoucherList?.length;
});
// 当前商品是否在秒杀活动中
const inSecKill = computed(() => {
    const currentTime = Date.now();
    return (
        courseTradeInfo.value?.secKillInfoDTO &&
        currentTime >= courseTradeInfo.value?.secKillInfoDTO.secKillStartTime &&
        currentTime <= courseTradeInfo.value?.secKillInfoDTO.secKillEndTime
    );
});
// 站外课是否是首次购买
const showUserInfoProtocalFlag = computed(() => {
    return (
        dataUserRole.value?.role !== 'TEACHER' &&
        (isOffSiteCourseFlag.value || dataGifts.value.length) &&
        dataUserRole.value?.needAgreePurchaseAgreement
    );
});
// 是否展示最近购课学生模块
const isShowStudent = computed(() => {
    return (
        (dataUserRole.value?.role === 'TEACHER' ||
            dataUserRole.value?.role === 'STUDENT') &&
        isLiveCourseFlag.value
    );
});
/**
 * 点击去广场触发
 */
const toSquare = () => {
    pushLogBridge('sendImmediately', 'CLICK', 'BOTTOM_MORE_BTN', {});
    if (!isInYoda && getUrlParam('jumptoapp') !== 'false') {
        openKsApp();
        return;
    }
    if (isFreeCourse.value) {
        Goto('/square/free-course?channel=courseDetail');
    } else {
        Goto(
            '/home/square/vision?channel=courseDetail&initialTabId=3&layoutType=4&useH5Bar=1&hyId=vision&enableWK=1',
        );
    }
};
/**
 * 点击导航栏的交互
 */
const checkNavAction = (type: string) => {
    let pos = 0;
    // 记录是点击触发的滚动
    navActionClick.value = true;
    // 选中对应的导航条tab
    navSelected.value = type;
    navOpacity.value = 1;
    // 顶部导航条占据的空间
    const navHeight = (window.innerWidth / 414) * 50;
    // 如果点击的是课程
    if (type === 'Lesson') {
        pos = ElementLesson.value?.$el?.offsetTop - navHeight + 3;
    }
    // 如果是评论
    if (type === 'Comment') {
        pos = ElementComment.value?.$el?.offsetTop - navHeight;
    }
    // 如果是介绍
    if (type === 'Introduce') {
        const scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop; // 滚动条距离顶部的距离
        const windowHeight =
            document.documentElement.clientHeight || document.body.clientHeight; // 可视区的高度
        const scrollHeight =
            document.documentElement.scrollHeight || document.body.scrollHeight; //dom元素的高度，包含溢出不可见的内容
        void nextTick(() => {
            const posIntroduce =
                ElementIntroduce.value?.$el?.getBoundingClientRect();
            if (posIntroduce && Reflect.has(posIntroduce, 'top')) {
                if (
                    scrollHeight === scrollTop + windowHeight &&
                    posIntroduce.top > navHeight
                ) {
                    // 这里预留 ios12在滑到底部的时候偶现无法出触发点击事件，
                    return;
                } else {
                    pos = ElementIntroduce.value?.$el?.offsetTop - navHeight;
                }
            }
        });
    }
    if (type === 'Recommend') {
        pos = ElementRecommend.value?.$el?.offsetTop - navHeight - 20;
    }
    // 先解绑，ios有体验问题
    removePageScroll();
    setTimeout(() => {
        // 在绑定回来
        fixPageScroll();
    }, 60);
    window.scrollTo(0, pos);
};
/**
 * 展示领取弹窗,将开关置为true
 */
const voucherPopupShow = () => {
    voucherPopupFlag.value = true;
};
/**
 * 关闭领取优惠券蒙层
 */
const voucherPopupClose = () => {
    voucherPopupFlag.value = false;
};
/**
 * 领取优惠券，如果用户有未领取的优惠券，页面会出现领取优惠券的弹窗，点击”收下“按钮触发领取的接口
 */
const voucherPopupConfirm = () => {
    const params = (voucherList.value || []).map((item: VoucherList) => {
        return {
            activityId: item?.activityId,
            promotionPlatform: item?.promotionPlatform,
        };
    });
    void receiveCoupons(params).then((res) => {
        if (res.result) {
            Toast.success('领取成功');
            fetchInitPage();
        } else {
            Toast.error(res?.error_msg || '网络错误');
        }
        // 关闭弹窗
        voucherPopupFlag.value = false;
    });
};
/**
 * 提交评价，调用提交接口
 */
const submitEvaluate = async () => {
    if (isEvaluating.value || !evaluate.value) {
        return false;
    }
    // 正在提交中
    isEvaluating.value = true;
    const params = {
        courseId: courseId,
        evaluate: evaluate.value,
        content: evaluateContent.value,
        tags:
            evaluate.value === 'UNSATISFIED' ? selectedEvaluateTags.value : [],
    };
    // 向后端提交用户评价信息
    const res: any = await evaluateCourse(params);
    if (res.result === 1) {
        // 关闭评价面板
        showEvaluateDialog.value = false;
        // Toast.success('评价成功');
        canCourseEvaluate.value = false;
        // 评价成功弹窗
        evaluateSuccessFlag.value = true;
        // 调一下页面初始化
        fetchInitPage();
    } else {
        Toast.error(res.error_msg || '评价失败');
        reportCustomEvent({
            name: '提交评价事件',
            result_type: '提交评价失败',
            message: '提交评价失败',
            extra_info: {
                courseName: dataCourseFirst.value?.name,
                courseId: dataCourseFirst.value?.courseId,
                failMessage: res.error_msg,
            },
        });
    }
    // 记录提交结束
    isEvaluating.value = false;
};
/**
 * 评论文本框的一些适配
 */
const onEvaluateBlur = () => {
    window.scrollTo(0, 0);
};
/**
 * 打开评价弹窗
 */
const toEvaluate = () => {
    showEvaluateDialog.value = true;
};
/**
 * 当用户选择不满意的时候，底下会出现响应的不满意原因标签，这个方法用于记录用户点了哪些标签
 */
const selectEvaluateTag = (tag: string) => {
    if (selectedEvaluateTags.value.includes(tag)) {
        selectedEvaluateTags.value = selectedEvaluateTags.value.filter(
            (item) => item !== tag,
        );
    } else {
        selectedEvaluateTags.value.push(tag);
    }
};
/**
 * 打开评价面板的时候，点击“不满意||还行||很棒”触发的方法
 */
const selectEvaluate = (item: CourseEvaluateItem) => {
    evaluate.value = item.value;
};
/**
 * 关闭评价弹窗
 */
const cancelEvaluate = () => {
    showEvaluateDialog.value = false;
};
/**
 * 存在通过分享途径在端外访问商详页的情况，调用此方法唤起快手App
 */
const openKsApp = () => {
    openOrDownload({
        position: 'course-detail',
        schemeUrl: `kwai://webview?url=${encodeURIComponent(deepLink.value)}`,
    });
};
// 消费协议
const goUserProtocol = () => {
    Goto(
        'https://ppg.viviv.com/doodle/kYbIxjbX.html?uni_src=SMKMRQ&hyId=jimu_kYbIxjbX&layoutType=4',
    );
};
// 购买分销者课程的协议
const goDistributionProtocol = () => {
    Goto(
        'https://ppg.viviv.com/doodle/bUgVONTK.html?uni_src=other_secondary_page&layoutType=4',
    );
};
// 用户协议
const goUserInfoProtocol = () => {
    Goto('https://ppg.m.etoote.com/doodle/BklTItvU.html?hyId=jimu_BklTItvU');
};
/**
 * 报名免费课，调起接口
 */
const doSubscribe = (successText, isFreeFilm, isFollowSuccess) => {
    const backUpMsg = isFreeFilm ? '收藏失败，再试试吧' : '报名失败，再试试吧';
    return subscribeFreeCourse(courseId)
        .then((res: any) => {
            if (res.result === 1) {
                if (isFollowSuccess) {
                    void showAlertDialog({
                        title: isFreeFilm ? '收藏成功' : '报名成功',
                        content: successText,
                    });
                } else {
                    const accountName = isFreeFilm ? '快手影视' : '快手课堂';
                    Toast.error(
                        `网络不好，请搜索“${accountName}”并关注，获取视频链接`,
                    );
                }
            } else {
                'result' in res
                    ? Toast.error(res.error_msg || backUpMsg)
                    : Toast.error(backUpMsg);
            }
        })
        .catch(() => {
            Toast.error(backUpMsg);
        });
};
/**
 * 取消免费课报名,调起报名接口
 */
const doUnsubscribe = () => {
    return unsubscribeFreeCourse(courseId)
        .then((res: any) => {
            if (res.result === 1 && isLiveCourseFlag.value) {
                Toast.success('已取消报名');
            }
        })
        .catch((err) => {
            Toast.error(err.error_msg);
        });
};
/**
 * 报名免费课或是取消免费课报名，点击底部按钮触发
 */
const toSubscribe = async (isFreeFilm: boolean) => {
    if (!isInYoda) {
        openKsApp();
        return;
    }
    // 七分屏情况处理
    fixSevenScreenBottomBtn();
    let successText = isFreeFilm
        ? '你已关注“快手影视”官方账号，可通过私信查看已收藏视频'
        : '你已关注“快手课堂”官方账号，可通过私信查看报名详情';
    let isFollowSuccess = true;
    // 如果是直播课
    if (!isFreeFilm && isLiveCourseFlag.value) {
        successText = dataUserRole.value?.officialFollowed
            ? '开课前，你将收到消息提醒，请注意查收'
            : '你已关注“快手课堂”官方账号，开课前将会收到消息提醒，请注意查收';
    }
    if (
        !dataUserRole.value?.officialFollowed &&
        !dataUserRole.value?.courseSubed
    ) {
        // 传入官方账号id
        const followRes: any = isFreeFilm
            ? await followUserByApi(40300007)
            : await followUserByApi(40300037);
        isFollowSuccess = followRes && followRes.result === 1;
    }
    dataUserRole.value?.courseSubed
        ? await doUnsubscribe()
        : await doSubscribe(successText, isFreeFilm, isFollowSuccess);
    // 这里调用一下初始化方法
    fetchInitPage();
};
/**
 * 以下是封装的是给用户一些信息提示的方法，
 *****************************************************************************************************************************************/
/**
 * 直播转录播，买直播课的人也能看录播课，处理这个交互逻辑
 */
const handleRestartCourse = () => {
    // 如果是视频课
    if (isVideoCourseFlag.value) {
        void showConfirmDialog({
            title: '温馨提示',
            content: '此付费视频是你购买过的直播的回放，你可直接去原直播观看。',
            confirmBtnText: '去看看',
            onConfirm: () => {
                Goto(
                    `/detail/${dataUserRole.value?.sourceCourseId}?channel=fromBoughtSame`,
                );
            },
            cancelBtnText: '取消',
            onCancel: () => {
                // 埋点预留
            },
        });
    } else if (dataCourse.value?.category === 'COURSE') {
        void showConfirmDialog({
            title: '温馨提示',
            content: '你已购买过相同内容的付费直播，是否要重复购买？',
            confirmBtnText: '继续购买',
            onConfirm: () => {
                buyCourse(null, true);
            },
            cancelBtnText: '取消',
            onCancel: () => {
                // 埋点预留
            },
        });
    } else {
        buyCourse(null, true);
    }
};
/**
 * 提醒用户去绑定手机号码
 * */
const bindThePhone = (cb) => {
    void showConfirmDialog({
        title: '购买成功',
        content:
            '你可通过【打开侧边栏-更多-付费内容-我购买的】查看直播。为避免错过直播，请先绑定手机，开播前将有短信通知。',
        confirmBtnText: '立即绑定',
        onConfirm: () => {
            invoke('social.bindPhone');
            cb && cb();
        },
        cancelBtnText: '暂不绑定',
        onCancel: () => {
            cb && cb();
        },
    });
};
/**
 * 以下这里是支付相关、以及拉起支付前一系列业务逻辑判断fun的封装，包括单节课购买，以及购买一整节课，强化用户知晓权益，拉起收银台，判断消费者账号是否被禁用等
 *****************************************************************************************************************************/
/**
 * 关闭交易面板,直接将开关关闭，多处会执行这个方法
 */
const hidePayCounterDialog = () => {
    showPayCounterDialog.value = false;
    // offSiteStudentInfoDialogDone.value = false;
};
/**
 * 关闭快币支付面板，直接将开关变为false
 */
const hideKsCoinIapListLayer = () => {
    showKsCoinIapListLayer.value = false;
};
/**
 * 购买完成&&确认用户已经有了这个（课||课节）的权益，则执行这个方法，会跳到购买完成引导页面
 */
const showBuySuccess = async () => {
    if (isOffSiteCourseFlag.value) {
        offsiteBoughtSuccessVisible.value = true;
    } else {
        // 这里再执行一下初始化接口
        fetchInitPage();
        Goto(
            `/kt/buy-detail/?id=${window.out_order_no}&courseType=${dataCourse.value?.courseType}&enableWK=1&layoutType=4&useH5Bar=1&hyId=vision&channel=`,
        );
        pushLogBridge('sendImmediately', 'CLICK', 'BUY_COURSE_SUCCESS');
    }
};
/**
 * 拉起快币收银台支付
 */
const payByKsCoin = async (
    lessonId = 0,
    params: { giftAddressId?: number; remark?: string },
) => {
    // 正在支付中
    isPaying.value = true;
    if (userStatus.value !== 1) {
        // 隐藏交易面板
        hidePayCounterDialog();
        showAccountExceptionDialog(
            () => {
                Goto(feedbackUrl);
            },
            () => {
                // 埋点预留
            },
        );
        return;
    }
    // 当前用户是否存在异常
    if (!checkUserBanned()) {
        return;
    }
    // 快币支付且快币余额充足 或 人民币的(优惠券)购买 人民币优惠券购买才会弹窗
    if (
        (useKscoinPay.value && product.value.price / 10 <= userBalance.value) ||
        !useKscoinPay.value
    ) {
        // 一个是处理课节，一个是处理整个课，params可能会包含赠品课的相关信息
        await (lessonId
            ? doPayForLesson(lessonId, params)
            : doPayForCourse(params));
    } else {
        // 快币余额不足 显示充值弹窗
        showKsCoinIapListLayer.value = true;
        pushLogBridge('sendImmediately', 'SHOW', 'BUY_KSCOIN_POP');
    }
    // 隐藏交易面板
    hidePayCounterDialog();
    isPaying.value = false;
};
/**
 * 支付完成后（整个课），需要业务后台确认一下当前用户是否有这节课的权益，调用这个方法
 */
const verifyCourseResult = () => {
    // sharpUI的loading
    ActivityIndicator.show();
    // 支完成后，确认用户是否已经获得权益
    checkPayCourse(dataCourse.value?.courseId)
        .then((res: any) => {
            // 不知道这一步是做啥用的，历史保留下来的
            if (res.data.courseSettingInfo && res.data.courseSettingInfo.text) {
                setSettingEntryForCourse(res.data.courseSettingInfo);
            }
            // 购买站外课完成后, 根据接口弹出领取链接, 然后弹出用户权益提醒
            // 如果接口没有返回领取功能,则权益提醒直接弹出
            if (isOffSiteCourseFlag.value) {
                const contentAcquisition = res?.data?.contentAcquisition;
                if (contentAcquisition?.contentAcquisitionMode === 1) {
                    receiveLinkUrl.value =
                        contentAcquisition?.contentAcquisitionURL[0];
                    receiveQrcodeUrl.value = '';
                    receivePopShow.value = true;
                    isBuySuccessFlag.value = true;
                } else if (contentAcquisition?.contentAcquisitionMode === 2) {
                    receiveLinkUrl.value = '';
                    receiveQrcodeUrl.value =
                        contentAcquisition?.qrCodeImgUrls[
                            contentAcquisition?.qrCodeImgKeys[0]
                        ][0];
                    receivePopShow.value = true;
                    isBuySuccessFlag.value = true;
                } else {
                    showBuySuccess();
                }
            } else if (isVideoCourseFlag.value) {
                // 如果是视频
                showBuySuccess();
            } else if (isLiveCourseFlag.value) {
                if (res.data.needUpdatePhone) {
                    // 需要绑定手机号的话
                    bindThePhone(() => {
                        // 购课后指引
                        showBuySuccess();
                    });
                } else {
                    showBuySuccess();
                }
            }
        })
        .catch((e) => {
            // 埋点预留
            Toast.error(e.error_msg || e.message);
        })
        .finally(() => {
            ActivityIndicator.hide();
            commodityId.value = null;
        });
};
/**
 * 支付完成后（单节课），需要业务后台确认一下当前用户是否有这节课的权益，调用这个方法
 * @lessonId 课节的id
 */
const verifyLessonResult = (lessonId) => {
    // sharpUi的loading方法，这里是展示loading
    ActivityIndicator.show();
    // 确认是否已有了这个课节的权益
    checkPayLesson(lessonId)
        .then((res: any) => {
            if (res.result === 1) {
                showBuySuccess();
            }
        })
        .catch((e) => {
            Toast.error(e.error_msg || e.message);
        })
        .finally(() => {
            ActivityIndicator.hide();
            commodityId.value = null;
        });
};
/**
 * 支付完成（从支付中台回来）之后执行的回调，处理一下交互的逻辑
 * @ret 是支付完成回传的参数
 * @lessonId 主要是用于记录是整个课购买还是单节课的购买
 */
const onPaySuccess = (ret, lessonId) => {
    // 先把交易面板关闭
    hidePayCounterDialog();
    if (ret && ret.error_msg === '') {
        // 如果是课节的购买
        if (lessonId) {
            verifyLessonResult(lessonId);
        } else {
            verifyCourseResult();
        }
        // 支付事件上报监控
        reportCustomEvent({
            name: '用户支付事件',
            event_type: '收起支付面板',
            result_type: '购买成功',
            message: lessonId ? '成功购买单个课节' : '成功购买整个课程',
            extra_info: {
                courseName: dataCourseFirst.value?.name,
                courseId: dataCourseFirst.value?.courseId,
            },
        });
        pushLogBridge(
            'sendImmediately',
            'BACKGROUND_TASK_EVENT',
            'PAYMENT_CALLBACK',
            {
                payment_result: '成功',
                courseId,
            },
        );
        reportTransformEventEnd({
            name: '订单转化率',
        });
        return;
    }
    if (ret.result && ret.error_msg) {
        Toast.error(ret.error_msg);
        reportCustomEvent({
            name: '用户支付事件',
            event_type: '收起支付面板',
            result_type: '购买失败',
            message: lessonId ? '购买单个课节失败' : '成功购买整个课程失败',
            extra_info: {
                courseName: dataCourseFirst.value?.name,
                courseId: dataCourseFirst.value?.courseId,
                result: ret.result,
                failMessage: ret.error_msg,
            },
        });
        pushLogBridge(
            'sendImmediately',
            'BACKGROUND_TASK_EVENT',
            'PAYMENT_CALLBACK',
            {
                payment_result: '失败：' + ret.error_msg,
                courseId,
            },
        );
    }
};
const showDownloadDialog = (
    e: Record<'error_msg' | 'message', string> & {
        __requestErrorHandled?: boolean;
    },
) => {
    if (e.__requestErrorHandled) {
        return;
    }
    // 临时特殊逻辑，提示去商店下载水印版本
    const re = /^\[300001\]/;
    if (re.test(e.error_msg)) {
        const msg = e.error_msg.replace(re, '');
        if (kpn === 'NEBULA') {
            Toast.info(msg);
            return;
        }
        openOrDownloadKsApp(msg);
    } else {
        const msg = e.error_msg || e.message;
        !!msg && Toast.error(msg);
    }
};
/**
 * 购买整个课，拉起收银台支付（给支付中台）
 * @ret 是支付完成回传的参数
 * @lessonId 主要是用于记录是整个课购买还是单节课的购买
 */
const payForCourseHandler = async (orderParam) => {
    await payForCourse(orderParam)
        .then((res) => {
            // 支付完成后，把支付中台回传的数据传给onPaySuccess方法，用于后续的交互，0代表的是整个课购买
            onPaySuccess(res, 0);
        })
        .catch((e) => {
            pushLogBridge(
                'sendImmediately',
                'BACKGROUND_TASK_EVENT',
                'PAYMENT_CALLBACK',
                {
                    payment_result: '失败：' + (e.error_msg | e.message),
                    courseId,
                },
            );
            // 页面初始化一下
            fetchInitPage();
            if (e && e.result !== 0) {
                showDownloadDialog(e);
            }
            reportCustomEvent({
                name: '用户支付事件',
                event_type: '收起支付面板',
                result_type: '购买异常',
                message: '支付回调存在异常信息',
                extra_info: {
                    courseName: dataCourseFirst.value?.name,
                    courseId: dataCourseFirst.value?.courseId,
                    result: e.result,
                    failMessage: e.error_msg || e.message,
                },
            });
        })
        .finally(() => {
            // 页面初始化一下
            fetchInitPage();
        });
};
/**
 * 确认开始支付，执行购买整个课程的方法
 * @lessonId 课节的id
 * @param 赠品课相关的信息
 */
const doPayForCourse = async (
    params: { giftAddressId?: number; remark?: string } = {},
) => {
    const courseId = dataCourse.value?.courseId;
    const channel = getUrlParam('channel');
    let activityObj;
    // 如果有秒杀活动，这里要拿出秒杀活动的信息
    if (courseTradeInfo.value?.secKillInfoDTO) {
        // 获取秒杀活动信息
        activityObj = {
            activityId: courseTradeInfo.value?.secKillInfoDTO?.activityId,
            activityType: courseTradeInfo.value?.secKillInfoDTO?.activityType,
        };
    }
    // 生成订单所需要的参数
    const orderParam: Record<string, any> = {
        callback: getUrlParam('adCallback') || '',
        courseId,
        channel,
        sparkInfo: {
            taskId: getUrlParam('taskId') || '',
            photoId: getUrlParam('photoId') || '',
            accountId: getUrlParam('authorId') || '',
        },
        useKscoinPay: useKscoinPay.value,
        commodityId: commodityId.value,
        expireTime: -1,
        // @ts-ignore
        price: product.value?.price,
        courseDistributionId: distributionId,
        distributionId: distributionId,
        activityInfo: inSecKill.value ? activityObj : null,
        ...params,
    };
    // 过滤出优惠券所用的信息
    // @ts-ignore
    if (product.value?.vouchers.length) {
        // @ts-ignore
        orderParam.voucherList = product.value.vouchers.map((voucher) => ({
            voucherId: voucher.voucherId,
            promotionPlatform: voucher.promotionPlatform,
        }));
    }
    // 支付前还要判断如果进入页面的时候有秒杀活动，付款时候是否已经超时结束了
    // 为了避免支付收银台调起时候还在秒杀 但付款时秒杀结束了
    // 只有有秒杀活动 且活动结束后activityEnd才为true
    if (
        courseTradeInfo.value?.secKillInfoDTO &&
        Date.now() >= courseTradeInfo.value?.secKillInfoDTO.secKillEndTime
    ) {
        orderParam.activityInfo = null;
        void showConfirmDialog({
            title: '温馨提示',
            content: '秒杀活动已结束，是否以原价继续购买？',
            confirmBtnText: '立即支付',
            onConfirm: () => {
                // 购买整个课，拉起收银台
                payForCourseHandler(orderParam);
            },
            cancelBtnText: '再想想',
            onCancel: () => {
                // 页面初始化一下
                fetchInitPage();
            },
        });
    } else {
        // 购买整个课，拉起收银台
        payForCourseHandler(orderParam);
    }
};
/**
 * 确认开始支付，执行购买单节课程的方法
 * @lessonId 课节的id
 * @param 赠品课相关的信息
 */
const doPayForLesson = async (
    lessonId: number,
    params: { giftAddressId?: number; remark?: string } = {},
) => {
    let activityObj;
    // 如果有秒杀活动，这里要拿出秒杀活动的信息
    if (courseTradeInfo.value?.secKillInfoDTO) {
        // 获取秒杀活动信息
        activityObj = {
            activityId: courseTradeInfo.value?.secKillInfoDTO?.activityId,
            activityType: courseTradeInfo.value?.secKillInfoDTO?.activityType,
        };
    }
    // 生成订单信息,传给后端
    const orderParam = {
        callback: getUrlParam('adCallback') || '',
        lessonId,
        channel: getUrlParam('channel'),
        useKscoinPay: useKscoinPay.value,
        commodityId: commodityId.value,
        expireTime: -1,
        // @ts-ignore
        price: product.value?.price,
        courseDistributionId: distributionId,
        distributionId: distributionId,
        activityInfo: inSecKill.value ? activityObj : null,
        voucherList: [],
        ...params,
    };
    // 过滤出优惠券有用的信息
    // @ts-ignore
    if (product.value?.vouchers.length) {
        // @ts-ignore
        orderParam.voucherList = product.value?.vouchers.map((voucher) => ({
            voucherId: voucher.voucherId,
            promotionPlatform: voucher.promotionPlatform,
        }));
    }
    // 这里执行的就是支付，调起支付中台
    // @ts-ignore
    await payForLesson(orderParam)
        .then((res) => {
            // 支付完成后，把支付中台回传的数据传给onPaySuccess方法，用于后续的交互，lessonId是用于记录购买课节的
            onPaySuccess(res, lessonId);
        })
        .catch((e) => {
            // 初始化一下
            fetchInitPage();
            if (e && e.result !== 0) {
                showDownloadDialog(e);
            }
        });
};
/**
 * 封装一个获取用户账户余额以及账户状态的方法，点击支付 与 在拉起支付面板之前调用
 */
const getPayInfo = () => {
    isRefreshingBalance.value = true;
    // 这个是sharpUi提供的一个loading，详细看sharpUI文档，这里是展示loading（复用的老的逻辑）
    ActivityIndicator.show();
    return getOrderPrepayInfo()
        .then((res) => {
            if (res.result === 1) {
                userBalance.value = res.data.userBalance;
                userStatus.value = res.data.userStatus;
                userBanned.value = res.data.userBanned;
                // this.formatCourse(this.courseDetail, this.useKscoinPay);
            }
            // 这个是sharpUi提供的一个loading，详细看sharpUI文档，这里是隐藏loading（复用的老的逻辑）
            ActivityIndicator.hide();
            return res;
        })
        .finally(() => {
            // 这个是sharpUi提供的一个loading，详细看sharpUI文档，这里是隐藏loading（复用的老的逻辑）
            ActivityIndicator.hide();
            isRefreshingBalance.value = false;
        });
};
/**
 * 如果是快币支付，当前用户充值快币成功后执行的方法
 * @ret 充值成功后的回传信息
 * @isCoinEnough 充值后价格是否足够支付
 */
const chargeSuccess = (ret, isCoinEnough) => {
    Toast.success('充值成功');
    void getPayInfo().then((res) => {
        if (res.result === 1) {
            // 获取亏快币充值面板上面的展示数据
            fetchKsCoinIapList();
            if (isCoinEnough) {
                // 隐藏交易面板
                hideKsCoinIapListLayer();
                // 支付课程
                doPayForCourse();
            }
        }
    });
};
/**
 * 充值失败
 */
const chargeFail = (e: any) => {
    Toast.error(e.error_msg || '充值失败');
};
/**
 * 让快币充值面板重新获取账户信息
 */
const refreshBalance = () => {
    // 获取当前消费者的账户信息
    getPayInfo();
};
/**
 * 这个方法是获取快币面板数据的
 */
const fetchKsCoinIapList = async () => {
    if (useKscoinPay.value) {
        await getKsCoinIapList().then((res: any) => {
            if (res.result === 1) {
                ksCoinIapList.value = (res.data as KsCoinIapItem[]) || [];
            }
            // 未成年
            if (res.result === 11) {
                nonage.value = true;
            }
            return res;
        });
    }
};
/**
 * 判断消费者的账号是否存在异常状况
 */
const checkUserBanned = () => {
    // 说明当前消费者账号被禁用
    if (userBanned.value) {
        const content = canDiscount.value ? '无法使用优惠券' : '暂时无法购买。';
        void showAlertDialog({
            title: '温馨提示',
            content: `您的账号处于异常状态，${content}`,
            confirmBtnText: '我知道了',
        });
        return false;
    }
    return true;
};
/**
 * 点击购课时候（站外履约课或是赠品课），如果没有同意协议，会弹窗一个同意协议弹窗，这里的这个方法是在点击弹窗的“同意”按钮之后触发，拉起填写信息弹窗
 */
const agreeUserInfoProtocol = () => {
    myProtocolFlag.value = true;
    // 关闭同意协议弹窗
    offSiteBoughtNoticePopupShow.value = false;
    // 如果是站外课的话
    if (isOffSiteCourseFlag.value) {
        // 拉起信息填写弹窗，这个弹窗会填写学员姓名、联系方式、备注信息
        commodityId.value = courseTradeInfo.value?.skuList[0].commodityId;
        offSiteStudentInfoDialogShow.value = true;
    } else {
        // 赠品（赠品弹窗在购买方法中调起,如果是单个课节则调起处理单个课节的方法）
        lesson.value?.lessonId
            ? buyOneLesson(lesson.value)
            : buyCourse(null, false);
    }
};
/**
 * 当学员填写玩站外履约课需要输入的信息之后，触发次方法，会拉起课程or课节购买
 */
const offSiteStudentInfoSubmitSucess = () => {
    // 隐藏站外履约课的信息填写弹窗
    offSiteStudentInfoDialogShow.value = false;
    // 记录已经填写完
    offSiteStudentInfoDialogDone.value = true;
    lesson.value?.lessonId
        ? buyOneLesson(lesson.value)
        : buyCourse(null, false);
    offSiteStudentInfoDialogDone.value = false;
};
/**
 * 当学员点击同意协议弹窗上的同意按钮触发
 */
const agreeProtocol = () => {
    myProtocolFlag.value = true;
    lesson.value?.lessonId
        ? buyOneLesson(lesson.value)
        : buyCourse(null, false);
};
/**
 * 用于强化用户在购课之前勾选统一协议行为
 */
const checkBuy = () => {
    if (!checkLogin()) {
        return false;
    }
    // 如果没有勾选协议的话
    if (!myProtocolFlag.value) {
        // 如果是站外履约课或是赠品课的话
        if (isOffSiteCourseFlag.value || dataGifts.value.length) {
            // 弹出确认同意协议的弹窗
            offSiteBoughtNoticePopupShow.value = true;
            pushLogBridge('sendImmediately', 'SHOW', 'PROTOCOL_POPUP', {
                law_agreement_version: distributionId
                    ? '好课推荐付费内容消费者协议20240327'
                    : '付费内容消费者用户协议20221226',
                personal_info_agreement_version: showUserInfoProtocalFlag.value
                    ? '个人信息授权协议20220224'
                    : '',
            });
        } else {
            // 弹出确认同意协议的弹窗
            boughtNoticePopupShow.value = true;
            pushLogBridge('sendImmediately', 'SHOW', 'PROTOCOL_POPUP', {
                law_agreement_version: distributionId
                    ? '好课推荐付费内容消费者协议20240327'
                    : '付费内容消费者用户协议20221226',
            });
        }
        return false;
    }
    if (isNebula && isAndroid && compareVersionNew('2.1') < 0) {
        showAlertDialog({
            title: '温馨提示',
            content: '极速版暂时无法观看此视频，可下载快手app观看。',
            confirmBtnText: '我知道了',
        });
        return false;
    }
    // 如果老师账号存在异常
    if (isBanned.value) {
        showAlertDialog({
            title: '温馨提示',
            content: '作者帐号状态异常，暂时无法购买。',
            confirmBtnText: '我知道了',
        });
        return false;
    }
    return true;
};
/***
 * 当时帮卖课程商详页时候，如果是ios系统且是人民币支付，则正常购买，否则就要给弹窗提示
 */
const isSupportBuy = computed(() => {
    if (distributionId && isIOS && useKscoinPay.value) {
        return false;
    }
    return true;
});

/**
 * RN 支付 - 购买单节课
 * @param lessonId 课节ID
 * @param lessonItem 课节数据
 * @returns 是否成功执行（成功返回true，失败或降级返回false）
 */
const newPayForLesson = async (
    lessonId: number,
    lessonItem: CourseDetailLessons,
): Promise<boolean> => {
    try {
        // 单个课节的交易信息取出来
        const commodityTradeInfo = lessonTradeInfoMap.value?.[lessonId];
        // 调用 RN 支付面板
        const result = await openPayCounter({
            lessonId: lessonId,
            courseId: dataCourse.value?.courseId,
            price:
                commodityTradeInfo?.actualPrice || commodityTradeInfo?.maxPrice,
            distributionId: distributionId,
            channel: channel,
            from: from,
            extInfo: {
                relatedId: dataCourse.value?.courseId as number,
                lessonId: lessonId,
                commodityName: lessonItem.name,
                userBalance: userBalance.value,
                userStatus: userStatus.value,
                useKscoinPay: useKscoinPay.value,
                userBanned: userBanned.value,
                price:
                    commodityTradeInfo?.actualPrice ||
                    commodityTradeInfo?.maxPrice,
            },
        });

        // 处理 RN 支付结果
        if (result.success) {
            // ✅ 支付成功，调用统一的权益校验流程（与 H5 支付保持一致）
            verifyLessonResult(lessonId);

            // 刷新页面数据
            fetchInitPage();
        } else if (result.message) {
            // 支付失败或取消，显示提示
            Toast.error(result.message);
        }
        return true; // 成功处理 RN 支付
    } catch (error: any) {
        console.error('[RN Payment] 单节课购买失败:', error);
        Toast.error(error?.message || '支付失败，请稍后重试');
        return false; // 降级到 H5 支付
    }
};

/**
 * RN 支付 - 购买整课
 * @returns 是否成功执行（成功返回true，失败或降级返回false）
 */
const newPayForCourse = async (): Promise<boolean> => {
    try {
        // 调用 RN 支付面板
        const result = await openPayCounter({
            courseId: dataCourse.value?.courseId as number,
            price:
                courseTradeInfo.value?.actualPrice ||
                courseTradeInfo.value?.maxPrice,
            distributionId: distributionId,
            channel: channel,
            from: from,
            extInfo: {
                relatedId: dataCourse.value?.courseId as number,
                commodityName: dataCourse.value?.name as string,
                userBalance: userBalance.value,
                userStatus: userStatus.value,
                useKscoinPay: useKscoinPay.value,
                userBanned: userBanned.value,
                price:
                    courseTradeInfo.value?.actualPrice ||
                    courseTradeInfo.value?.maxPrice,
            },
        });

        // 处理 RN 支付结果
        if (result.success) {
            // ✅ 支付成功，调用统一的权益校验流程（与 H5 支付保持一致）
            verifyCourseResult();

            // 刷新页面数据
            fetchInitPage();
        } else if (result.message) {
            // 支付失败或取消
            Toast.error(result.message);
        }
        return true; // 成功处理 RN 支付
    } catch (error: any) {
        console.error('[RN Payment] 整课购买失败:', error);
        Toast.error(error?.message || '支付失败，请稍后重试');
        return false; // 降级到 H5 支付
    }
};

/**
 * 购买单节课程，触发的方法
 * @lesson 课程的item数据
 */
const buyOneLesson = async (lessonItem: CourseDetailLessons) => {
    if (agreeFollow.value) {
        // 购买新营销课程时，关注「快手付费内容助手」
        pushLogBridge('sendImmediately', 'CLICK', 'FOLLOW_BTN', {
            source_type: '自动关注',
        });
        followUser(officialKsUid.PAIDCONTENT);
    }
    // 先把商品id置空
    commodityId.value = null;
    // this.expireTime = -1;
    if (!isInYoda) {
        openKsApp();
        return;
    }
    // 当时帮卖课程商详页时候，如果是ios系统且是人民币支付，则正常购买，否则就要给弹窗提示
    // if (!isSupportBuy.value) {
    //     Toast.info('苹果用户暂时不支持购买');
    //     return;
    // }
    // 把选中的课节单独拎出来记录下
    lesson.value = lessonItem;
    const lessonId = lessonItem.lessonId;
    // 判断用户的设备状况或是异常状况，如果有异常则跳出来
    if (!checkBuy()) {
        // 这里埋点预留
        return;
    }
    // 当是站外履约课，而且用户还没有完成个人信息填写，弹出相应的填写弹窗
    if (isOffSiteCourseFlag.value && !offSiteStudentInfoDialogDone.value) {
        offSiteStudentInfoDialogShow.value = true;
        return;
    }
    // 在拉起面板之前，先获取用户的账户状态，这里关心生产者的余额以及账号是否被禁用
    const payInfoRes = await getPayInfo();
    if (payInfoRes.result !== 1) {
        return;
    }
    // 如果账号被禁用了，则给一个弹窗提醒
    if (!checkUserBanned()) {
        return;
    }
    pushLogBridge('sendImmediately', 'CLICK', 'PROTOCOL_POPUP_BUY_BTN', {
        law_agreement_version: distributionId
            ? '好课推荐付费内容消费者协议20240327'
            : '付费内容消费者用户协议20221226',
        personal_info_agreement_version:
            showUserInfoProtocalFlag.value &&
            (isOffSiteCourseFlag.value || dataGifts.value.length)
                ? '个人信息授权协议20220224'
                : '',
    });

    // ===== RN 支付流程 =====
    if (useRNPay.value) {
        const success = await newPayForLesson(lessonId, lessonItem);
        if (success) {
            return; // RN 支付成功，结束流程
        }
        // success 为 false 时，降级到 H5 支付，继续执行下面的逻辑
    }
    // ===== 结束 RN 支付流程 =====

    // 如果以上的条件都满足了，先判断一下和快币相关的情况
    await fetchKsCoinIapList();
    // 单个课节的交易信息取出来
    // @ts-ignore
    const commodityTradeInfo = lessonTradeInfoMap.value[lessonId];
    // 这些信息是要传给交易面板的
    product.value = {
        name: lesson.value.name,
        price: commodityTradeInfo.actualPrice || commodityTradeInfo.maxPrice,
        originPrice: commodityTradeInfo.maxPrice,
        vouchers: commodityTradeInfo.recommendedCombinationVoucherList || [],
        // originPrice: this.model.originPrice,
        lessonId: lessonId,
        courseId: dataCourse.value?.courseId as number,
    };
    // @ts-ignore
    commodityId.value =
        // @ts-ignore
        lessonTradeInfoMap.value[lessonId].skuList[0].commodityId;
    // 买课节弹窗条件: 1. 优惠券 2. 快币支付
    if (
        commodityTradeInfo.recommendedCombinationVoucherList?.length ||
        useKscoinPay.value
    ) {
        showPayCounterDialog.value = true;
    } else {
        // 人民币支付且没有优惠券，直接购买，有这个方法生成订单
        doPayForLesson(lessonId);
    }
};
/**
 * 购买整个课程
 */
const buyCourse = async (ev, force = false) => {
    if (agreeFollow.value) {
        // 购买新营销课程时，关注「快手付费内容助手」
        pushLogBridge('sendImmediately', 'CLICK', 'FOLLOW_BTN', {
            source_type: '自动关注',
        });
        followUser(officialKsUid.PAIDCONTENT);
    }
    lesson.value = {} as CourseDetailLessons;
    // 先把商品id置空
    commodityId.value = null;

    if (!isInYoda) {
        openKsApp();
        return;
    }
    // 处理七分屏情况
    fixSevenScreenBottomBtn();
    // 当时帮卖课程商详页时候，如果是ios系统且是人民币支付，则正常购买，否则就要给弹窗提示
    // if (!isSupportBuy.value) {
    //     Toast.info('苹果用户暂时不支持购买');
    //     return;
    // }
    // 如果快速复课课程仍然点击‘继续购买’，则强制执行购买
    if (!checkBuy()) {
        // 埋点预留
        return;
    }
    // 取出商品id
    commodityId.value = courseTradeInfo.value?.skuList[0].commodityId;
    if (isOffSiteCourseFlag.value && !offSiteStudentInfoDialogDone.value) {
        // 弹出站外履约课的信息填写弹窗
        offSiteStudentInfoDialogShow.value = true;
        return;
    }
    // 复课逻辑，做一层弹窗拦截
    if (dataUserRole.value?.isSourceCourseStudent && !force) {
        handleRestartCourse();
        return;
    }
    // 是否卖光了
    if (!courseTradeInfo.value?.canPurchase) {
        return;
    }
    pushLogBridge('sendImmediately', 'CLICK', 'PROTOCOL_POPUP_BUY_BTN', {
        law_agreement_version: distributionId
            ? '好课推荐付费内容消费者协议20240327'
            : '付费内容消费者用户协议20221226',
        personal_info_agreement_version:
            showUserInfoProtocalFlag.value &&
            (isOffSiteCourseFlag.value || dataGifts.value.length)
                ? '个人信息授权协议20220224'
                : '',
    });
    // 在拉起面板之前，先获取用户的账户状态，这里关心生产者的余额以及账号是否被禁用
    const payInfoRes = await getPayInfo();
    if (payInfoRes.result !== 1) {
        return;
    }
    // 如果账号被禁用了，则给一个弹窗提醒
    if (!checkUserBanned()) {
        return;
    }

    // ===== RN 支付流程 =====
    if (useRNPay.value) {
        const success = await newPayForCourse();
        if (success) {
            return; // RN 支付成功，结束流程
        }
        // success 为 false 时，降级到 H5 支付，继续执行下面的逻辑
    }
    // ===== 结束 RN 支付流程 =====

    // 如果以上的条件都满足了，先判断一下和快币相关的情况
    await fetchKsCoinIapList();
    // 如果有有效期选择，在有效期选择后再进行支付操作
    product.value = {
        name: dataCourse.value?.name as string,
        vouchers:
            courseTradeInfo.value?.recommendedCombinationVoucherList || [],
        price: (courseTradeInfo.value?.actualPrice ||
            courseTradeInfo.value?.maxPrice) as number,
        originPrice: inSecKill.value
            ? courseTradeInfo.value?.secKillInfoDTO?.secKillPrice
            : courseTradeInfo.value?.maxPrice,
        lessonId: 0,
        courseId: dataCourse.value?.courseId as number,
    };
    // 弹窗的条件： 1. 优惠券 2. 快币支付 3. 有赠品
    // @ts-ignore
    if (
        product.value.vouchers.length ||
        useKscoinPay.value ||
        dataGifts.value.length
    ) {
        // 拉起交易面板
        showPayCounterDialog.value = true;
    } else {
        // 人民币支付且没有优惠券，直接购买
        doPayForCourse();
    }
};
/**
 * 以下这里是一些页面事件的回调，以及处理数据的一些方法，比如去看视频，跳到直播间
 **********************************************************************************************************************/
/**
 * 播放、试看、重播课程的方法，当点击课节的按钮（播放、试看、重播）时候触发，跳到对应的播放页面
 */
const playLessonVideo = (
    btnStatus: string,
    lessonItem: CourseDetailLessons,
) => {
    // 如果是端外的访问的这个页面
    if (!isInYoda) {
        openKsApp();
        return;
    }
    // 如果未登录的话，直接return
    if (!checkLogin()) {
        return;
    }
    // 极速版低于这个版本的时候，无法观看
    if (isNebula && isAndroid && compareVersionNew('2.1') < 0) {
        void showAlertDialog({
            title: '温馨提示',
            content: '极速版暂时无法观看此视频，可下载快手app观看。',
            confirmBtnText: '我知道了',
        });
        return;
    }
    // 如果是试看的话，目前试看非native会统一收口到详情页，这个要优先判断一下
    if (btnStatus === 'VIDEO_TRIAL') {
        // 时效性需求后, 低版本试看提示用户去升级
        videoLog({
            actionType: 'CLICK',
            actionName: 'LESSON_TRIAL_BTN',
            pageName: 'courseDetail',
            courseId: courseId,
            lessonId: lessonItem.lessonId,
            extParams: JSON.stringify({
                channel: getUrlParam('channel') || '',
            }),
        });
        if (compareVersionByOs(kwaiAppVersion[kpn].allowTrail) > 0) {
            openOrDownloadKsApp();
            return;
        }
    }
    // 如果以上的跳都能满足的话，那么就可以播放课程了
    try {
        // 跳到看视频的视频页
        void toVideo({
            lesson: lessonItem,
            pageName: 'course_detail',
            channel: getUrlParam('channel'),
            distributionId: distributionId,
            courseId: dataCourse.value?.courseId,
            pageSize: dataPageSize.value,
            feedView: dataFeedView.value,
        });
        if (!isLiveCourseFlag.value) {
            videoLog({
                actionType: 'PLAY_EVENT',
                actionName: 'START_PLAY',
                courseId: courseId,
                pageName: 'COURSE_DETAIL',
                lessonId: lessonItem.lessonId,
                timeStamp: +new Date(),
            });
        }
    } catch (error) {
        Toast.info((error as Error)?.message || '网络出错');
    }
};
/**
 * 直播课老师正在直播中，那么就跳到直播间
 */
const watchLessonLive = (lessonItem: CourseDetailLessons) => {
    // 如果是端外的话，唤起App
    if (!isInYoda) {
        openKsApp();
        return;
    }
    if (!dataCourse.value || !dataUserRole.value) {
        Toast.error('课程数据异常，请刷新重试');
        return;
    }
    // 鸿蒙不支持开通付费直播，老师开播时拦截
    if (dataUserRole.value.role === 'TEACHER' && isHarmony) {
        void showAlertDialog({
            title: '温馨提示',
            content: '当前暂不支持在鸿蒙端开通付费直播，请在其他端开播',
        });
        return;
    }
    void invoke('platform.loadUri', {
        url: getLiveUrl({
            courseId: dataCourse.value.courseId,
            lessonId: lessonItem.lessonId,
            courseName: dataCourse.value.name,
            lessonName: lessonItem.name,
            liveStreamId: lessonItem.liveStreamId,
            role: dataUserRole.value.role,
        }),
    });
};
/**
 * 点击课节按钮触发的动作，把他provide传给孙组件
 * @btnStatus 按钮点击时候对应的那个课节的状态，比如试看、播放、购买
 * @lessonItem 是对应课节的数据对象
 */
const clickLessonBtnEvent = (
    btnStatus: string,
    lessonItem: CourseDetailLessons,
): void => {
    // 直播课重播 || 视频课观看 || 视频课试看
    if (
        btnStatus === 'LIVE_REPLAY' ||
        btnStatus === 'VIDEO_WATCH' ||
        btnStatus === 'VIDEO_TRIAL'
    ) {
        playLessonVideo(btnStatus, lessonItem);
    }
    // 直播课，关于跳到直播间相关
    else if (btnStatus === 'LIVE_WATCH' || btnStatus === 'LIVE_TRIAL') {
        watchLessonLive(lessonItem);
    }
    // 如果是购买单节课课程
    else if (btnStatus === 'BUY_ONE_LESSON') {
        // 触发购买单节课程的方法
        buyOneLesson(lessonItem);
    }
    // 删除‘新’标签
    if (dataUserRole.value?.newLessonNotices) {
        dataUserRole.value.newLessonNotices.includes(lessonItem.lessonId)
            ? fixDelNotice(lessonItem.lessonId)
            : null;
    }
};
// 向孙组件传递clickLessonBtnEvent方法，用于触发试看，播放，购买课程等方法
provide('clickLessonBtnEvent', clickLessonBtnEvent);
/**
 * 点击底部的观看视频触发事件
 */
const toReplayList = () => {
    // 七分屏情况处理
    fixSevenScreenBottomBtn();
    // 只有一节课的视频课
    if (dataLessons.value.length === 1) {
        reportTransformEventStart({
            name: '观看视频事件',
            extra_info: {
                courseName: dataLessons.value[0].name, //课程名称
                courseId: dataLessons.value[0].lessonId, //课程id
            },
        });
        playLessonVideo('VIDEO_WATCH', dataLessons.value[0]);
        return;
    }
    // 直播课
    if (isLiveCourseFlag.value) {
        let targetLesson;
        dataLessons.value.forEach((item) => {
            if (item.videoStatus === 'NORMAL') {
                targetLesson = item;
                return;
            }
        });
        reportTransformEventStart({
            name: '观看视频事件',
            extra_info: {
                courseName: dataCourse.value?.name, //课程名称
                courseId: dataCourse.value?.courseId, //课程id
            },
        });
        playLessonVideo('VIDEO_WATCH', targetLesson);
        return;
    }
};
// 当获取到其他作者推荐数据触发(复购二期)
const changeShowRecommend = () => {
    showRecommend.value = true;
};
// 获取帮卖/分销/推荐的状态
const fixGetDistributionStatus = () => {
    void getDistributionStatus(courseId).then((res) => {
        dataMyDistributionStatus.value = res.data as MyDistributionStatus;
    });
};
// 当点击赚佣金时候触发的方法
const applyDistribution = () => {
    // 点击赚佣金的前置条件判断用户是否在黑名单里面
    if (dataUserRole.value?.inDistributorBlackList) {
        // 在黑名单内部则弹窗提示
        void showAlertDialog({
            title: '温馨提示',
            content:
                '您的账号存在虚假售卖/宣传等违规行为，禁止申请及售卖好课推荐内容，请联系官方客服处理~',
            confirmBtnText: '我知道了',
        });
        return;
    }
    // 如果用户不是生产者的话，提醒去成为生产者
    if (!dataUserRole.value?.isNormalTeacher) {
        void showConfirmDialog({
            title: '温馨提示',
            content: '进行好课推荐之前，需要先成为付费内容生产者呦~',
            confirmBtnText: '去看看',
            onConfirm: () => {
                Goto(`/apply/paid-content-author?layoutType=4`);
            },
            cancelBtnText: '再想想',
        });
        return;
    }
    // 判断用户的支付宝&微信的绑定状态,如果没绑定去绑定
    void getDistributorBindInfo().then((res) => {
        const sftBinded = res.data?.sftBinded;
        const zftBinded = res.data?.zftBinded;
        // 是否是机构账号
        const isOrg = res.data?.isOrg;
        if (!sftBinded || !zftBinded) {
            if (isOrg) {
                void showConfirmDialog({
                    title: '温馨提示',
                    content:
                        '你所在的机构未完成分销账户绑定，请联系机构主账号进行微信和支付宝提现账户绑定',
                    confirmBtnText: '去配置',
                    onConfirm: () => {
                        Goto('/org/bind?enableWK=1');
                    },
                    cancelBtnText: '再想想',
                });
            } else {
                distributionDialogVisable.value = true;
            }
        } else {
            // 如果以上条件都满足，则弹出确定分销的二次确认弹窗
            distributionConfirmFlag.value = true;
        }
    });
};
/**
 * 当点击确认帮卖弹窗的确认按钮后，走开通流程
 */
const distributionConfirmOk = () => {
    distributionConfirmFlag.value = false;
    pushLogBridge('sendImmediately', 'CLICK', 'PROTOCOL_DISTRIBUTE', {
        law_agreement_version: '付费内容好课推荐生产者帮卖者协议20220413',
    });
    void fixApplyDistribution(courseId).then((res) => {
        if (res.result == 1) {
            distributionConfirmSuccessFlag.value = true;
            fixGetDistributionStatus();
        } else if (res.result == 1101) {
            distributionDialogVisable.value = true;
        } else {
            Toast.error((res && res.error_msg) || '网络错误');
            reportCustomEvent({
                name: '分销事件',
                result_type: '分销失败',
                message: '分销失败',
                extra_info: {
                    courseId: courseId, //课程id
                    distributionId: distributionId, //帮卖者id
                    distributorName: distributorName, //帮卖者昵称
                    failMessage: res.error_msg,
                },
            });
        }
    });
};
/**
 * 当点击确认帮卖弹窗的取消按钮后，关闭弹窗
 */
const distributionCancel = () => {
    distributionConfirmFlag.value = false;
};

// 处理打点上报，以及适配问题
async function fixPageActionLog() {
    // 记录页面进入时间
    pageEnterTime.value = Date.now();
    // pv 上报
    try {
        const exptag = await getServerExpTag();
        initLogBridge(
            {
                exptag,
                course_id: courseId,
                source: distributionId ? 'DISTRIBUTION' : 'NORMAL',
                channel: getUrlParam('channel'),
            },
            {
                page: 'COURSE_DETAIL_V2',
                params: {
                    exptag,
                    course_id: courseId,
                    course_type: dataCourse.value?.courseType,
                    source: distributionId ? 'DISTRIBUTION' : 'NORMAL',
                    channel: getUrlParam('channel'),
                    lesson_id: Object.keys(lessonTradeInfoMap.value || {}).join(
                        ',',
                    ),
                    is_distribution: !!distributionId,
                    // 目前只有新营销
                    course_category: isNewMarketingCourse.value ? '新营销' : '',
                },
            },
            radar,
        );
    } catch (error) {
        console.error('weblog init error', error);
    }
    // 禁用ios双击页面移动
    iosDoubleCheck('#app');
    // 打点方法，记录播放时间节点用的
    videoLog = makeActionLog('COURSE');
    getCourseBrief({
        courseId,
        courseDistributionId: distributionId,
        channel,
    })
        .then(async ({ result, data }) => {
            // 获取首屏数据
            dataCourseFirst.value = data.course;
            // 标记loading态
            isLoading.value = LoadingState.done;
            void nextTick(() => {
                sendFMP();
            });
            await fetchInitPage(true);
        })
        .catch((err) => {
            // ...
        });
}
void fixPageActionLog();
// 站外课领取权益 bottom 弹框关闭
const changeReceiveType = (val) => {
    if (!val && isBuySuccessFlag.value) {
        void showBuySuccess();
        isBuySuccessFlag.value = false;
    }
};
onMounted(() => {
    const mark = document.getElementById('mark');
    if (mark) {
        mark.style.display = 'none';
    }
    if (mountedShowComment === '1') {
        showEvaluateDialog.value = true;
    }
});
onBeforeUnmount(() => {
    // 页面离开上报，用于计算跳出率和停留时长
    if (pageEnterTime.value) {
        const stayDuration = Date.now() - pageEnterTime.value;
        radar.event({
            name: '页面离开',
            category: 'COURSE_DETAIL_V2',
            event_type: 'leave',
            result_type: stayDuration < 3000 ? '秒退' : '正常离开',
            message: `${stayDuration}`,
            extra_info: {
                course_id: courseId,
                course_type: dataCourse.value?.courseType,
                channel: getUrlParam('channel'),
            },
        });
    }
    void removeListener('native_reentry', fetchInitPage);
    void removeListener('operation-paid-content-refresh-page', fetchInitPage);
});
const isCouponShow = ref(false);
const judgeCouponShow = async () => {
    try {
        const { data } = await heroAndPowerInfo();
        isCouponShow.value = data?.activities?.[0]?.status === 2;
    } catch (error) {
        isCouponShow.value = false;
    }
};
const checkBenefitCourse = () => {
    return request.get('/rest/lightks/wd/courses/courseBenefit', {
        params: {
            courseId,
        },
    });
};
const showDialog = (description?: string, link?: string) => {
    void showConfirmDialog({
        title: '温馨提示',
        content: description || '您不符合该课程赠品的领取要求，无法进行领取。',
        confirmBtnText: '立即参与',
        closeOnClickMask: false,
        closeOnClickBack: false,
        onConfirm: () => {
            window.location.replace(
                link ||
                    window['kConf_platecoDev.lightks.freeCourseJimuJumpUrl']
                        ?.url,
            );
        },
        cancelBtnText: '取消',
        onCancel: () => {
            window.location.replace(
                '/home/square/vision?channel=courseDetail&hyId=vision',
            );
        },
    });
};
onMounted(async () => {
    // await judgeCouponShow();
    checkBenefitCourse()
        .then((res) => {
            if (res.data && !res.data.courseBenefit) {
                !!res.data.showPopup &&
                    showDialog(res.data?.description, res.data?.link);
            }
        })
        .catch(() => {
            // showDialog();
        });
});
const goLink = () => {
    pushLogBridge('sendImmediately', 'CLICK', 'GRAB_COUPON_BANNER');
    Goto(
        '/kt/activity/?useH5Bar=1&enableWK=1&layoutType=4&hyId=vision&channel=fromSettingPage&carryType=fromSettingPage#/2025HeroCharge',
    );
};

const onUpdateClick = () => {
    void invoke('tool.loadUrlOnNewPage', {
        url: 'https://m.kuaishou.com/download/kwai?toMarket=true',
        type: 'back',
    });
};
</script>

<style lang="less">
@import '@/common/style/index.less';
img {
    -webkit-touch-callout: none;
}
.spu-mask {
    background-color: rgba(0, 0, 0, 0) !important;
}
</style>
<style lang="less" scoped>
.loading {
    position: fixed;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    margin: auto;
    text-align: center;
    background-color: #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;
}
.pendent {
    position: fixed;
    width: 60px;
    height: 60px;
    z-index: 10000;
}
.detail-content {
    min-height: 100vh;
    background-color: #f8f8f8;
}
.course-offline-tip {
    width: 100%;
    height: 40px;
    background: #ffeef2;
    position: sticky;
    z-index: 100;
    top: 0;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #fe3666;
    img {
        width: 16px;
        height: 16px;
        margin: 0 4px 0 19px;
    }
}
.offsite-bought-success-dialog {
    .content {
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        text-align: justify;
        color: #666;
        span {
            color: #000;
            font-weight: 500;
        }
        &.second {
            margin-top: 8px;
        }
    }
}
.pay-counter {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 9999;
}
// 这里是复用老板的样式代码，没有设计图，就只能保留rem
.evaluate-wrap {
    position: relative;
    background: #fff;
    color: #303030;
    padding: 28px 39px 24px;
    :deep(.spu-dialog__content) {
        width: 295px;
    }
    :deep(.spu-textarea__field) {
        padding: 5px 10px;
        background: #f6f6f6;
    }
    .e-title {
        color: #000;
        font-size: 18px;
        line-height: 1;
        text-align: center;
        margin-bottom: 24px;
        margin-top: 2px;
        font-weight: bold;
    }
    .e-content {
        height: 160px;
        border-radius: 4px;
        overflow: hidden;
        background: #f8f8f8;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        font-size: 0;
        position: relative;
        width: 100%;
        .e-content-textarea {
            border: none;
            box-sizing: border-box;
            caret-color: #fe3666;
            color: #222;
            flex: 1;
            font-size: 14px;
            height: 100%;
            line-height: 20px;
            padding: 8px 12px;
            resize: none;
            text-align: left;
            width: 100%;
        }
        .e-content-word-limit {
            color: #c6c6c6;
            display: flex;
            font-size: 14px;
            height: 22px;
            justify-content: flex-end;
            padding-top: 4px;
            padding-right: 12px;
        }
    }
    .e-select {
        display: flex;
        justify-content: space-between;
        color: #303030;
        margin-bottom: 24px;
        padding: 0 6px;
        .e-item {
            text-align: center;
            width: 66px;
            font-size: 14px;
            .e-i-img {
                width: 100%;
            }
            .e-i-label {
                text-align: center;
            }
        }
    }
    .evaluate-tags {
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        color: #666;
        overflow-y: scroll;
        margin-bottom: 10px;
        .e-tag {
            width: 104px;
            padding: 9px 0;
            border: 0.5px solid #eaeaea;
            border-radius: 4px;
            text-align: center;
            font-size: 12px;
            margin-bottom: 12px;
            &.active {
                background: #fff7f9;
                border: 1px solid #fe3666;
                border-radius: 4px;
                color: #fe3666;
                font-weight: 500;
            }
        }
        .e-tag-last {
            width: 104px;
        }
    }
    .spu-textarea__indicator {
        display: none;
    }
    .spu-textarea:after {
        border: none;
        border-radius: 4px !important;
        overflow: hidden;
    }
    .spu-textarea {
        textarea {
            caret-color: #fe3666;
            &::placeholder {
                font-size: 14px;
                line-height: 17px;
                color: #c6c6c6;
            }
        }
    }
    :deep(.submit-btn) {
        box-sizing: border-box;
        width: 300px;
        height: 56px;
        line-height: 56px;
        margin: 36px auto 18px;
        text-align: center;
        background-color: #fe3666;
        color: #fff;
        border-radius: 24px;
        font-weight: bolder;
        font-size: 16px;
    }
    :deep(.disabled) {
        opacity: 0.6;
    }
    .icon-close {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 16px;
        right: 16px;
        border: none;
    }
}
:deep(.offSiteDialog) {
    box-sizing: border-box;
    width: 280px;
    padding: 24px 24px 32px;
    background: #fff;
    border-radius: 12px;
    .title {
        margin-bottom: 12px;
        text-align: center;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        color: #222;
    }
    .content {
        font-size: 16px;
        line-height: 24px;
        text-align: justify;
        color: #666;
        margin-top: 12px;
        span {
            color: #fe3666;
        }
        &.second {
            margin: 12px 0 28px;
            span {
                color: #fe3666;
            }
        }
        &.first {
            margin-top: 0;
        }
    }
    .submit-btn {
        min-width: 168px;
        margin: 12px auto 0;
    }
}
.distribution-confirm {
    :deep(.distribution-confirm-layout) {
        .distribution-confirm-layout-writer {
            color: #666;
            margin: 0 24px 8px;
            line-height: 22px;
            font-size: 16px;
        }
    }
    :deep(.protocol) {
        padding: 0 24px;
        margin-left: -3px;
    }
    :deep(.distribution-confirm-layouts) {
        padding-bottom: 16px;
    }
}
.corporation {
    padding: 24px 0 12px;
    text-align: center;
    font-size: 12px;
    color: #c6c6c6;
}
</style>
